/*
 * rs-buybox.js: der eine Auswahl-Zustand der Seite (05 Abschnitt 8.2, 03 Abschnitt 1 Nr. 3).
 *
 * Zustand { modus: 'eine'|'zwei'|'set', farbe: 1|2, groesse1, groesse2, zusatz }. zusatz ist seit 13.10.2026 das Häkchen
 * der Bambus-Zeile über dem Kaufknopf (rs-bambus-zeile.liquid, ändert E-178): angehakt legen Kaufknopf, Kaufleiste und
 * Abschluss Auswahl und Bambus-Küchenhelferset in einem Aufruf hinein. Nie vorausgewählt; liegt Bambus im Warenkorb,
 * ist die Zeile verborgen und zusatz false.
 * Start: Theme-Standard und Produkt der URL (von Liquid vorgerendert), dann die URL-Parameter
 * auswahl, farbe, groesse (03 2.4). Keine gemerkte Auswahl (E-29).
 *
 * An diesem Zustand hängen Buybox (Karten mit aufklappender Größenwahl, Zweier-Ersparnis), Bühne
 * mit Galerie, Abschluss (rs-abschluss), Kaufleiste (rs-kaufleiste) und Express-Bereich. Angesagt
 * wird nur im Preisblock der Buybox, gebündelt und entprellt (400 ms, 04 A3.6).
 * Seit Feedback Runde 1 (25.09.2026): keine Bühnen-Zeile unter dem Bild, kein Klarna-Hinweis.
 * Seit 26.09.2026: Galerie Bild 1 ist das Set-Foto, Bild 2 die Kaufbühne (assets/rs-buehne.js,
 * window.RsBuehne). Anzahl und Größe springen auf Bild 2, die Farbe nicht (wahlNachAenderung).
 *
 * Rechnung über window.RSPreise (assets/rs-preise.js: preisDerWahl, vergleichDerWahl, buyboxKarten, zweierPaar,
 * formatEuro). Seit E-169 (29.09.2026) steht im Preisblock neben dem Preis „einzeln …“ (volle Einzelpreise,
 * ungestrichen) und dahinter die Plakette (preisZusatz, E-170 in derselben Zeile), beides nur beim Zweier und beim Set; fehlt das Modul,
 * rechnet lokalVergleichDerWahl.
 * Duo 20 % (01.10.2026): Der Zweier ist eine Variante des Bundles pfannen-duo. „In den Warenkorb“ und Express kaufen
 * dieselbe Variante (rechne), beide nur, wenn die Wache zweierPaar das Paar freigibt; sonst sind beide gesperrt, und über
 * dem Knopf steht zweier_gesperrt. Ohne rs-preise.js rechnen duoSumme und duoPaar dasselbe.
 * Daten aus dem JSON der Kaufbühne ([data-rs-buybox-daten]), Preise in Cent aus den Varianten.
 *
 * Hinzufügen (eine Funktion für Buybox, Kaufleiste und Abschluss): ein Aufruf /cart/add.js mit
 * items, gleiche Varianten zusammengefasst; gleichzeitig der Flug in den Topf (rs-flug.js). Danach
 * rs:warenkorb:hinzugefuegt mit detail.landung; den Warenkorb öffnet rs-cart.js (8.3, 8.6).
 * Die fetch-Funktion wird zum Aufrufzeitpunkt genommen (Web-Pixel hängen sich an window.fetch).
 * Früher Tipp (02.10.2026): Einen Tipp auf den Kaufknopf vor dem Start dieses Moduls hält ein kleines Skript hinter dem
 * Kaufformular an (rs-kaufbuehne.liquid). Vor dem Start Angetipptes (data-rs-beruehrt) gilt beim Start; beim Binden des
 * Kauf-Handlers holt fruehenTippAbholen den gemerkten Tipp ab, fruehenTippAusfuehren führt ihn nach dem ersten Zeichnen
 * aus, wenn die Auswahl dieselbe ist und nichts angetippt wurde, sonst sagt es die gültige Auswahl an.
 *
 * Ereignisse (8.6, nur intern, nie für Tracking; alle kommen am document an):
 *   sendet  rs:buybox:geaendert        am document; detail: Zustand, summe, einzelnSumme, ersparnis, verfuegbar, items, init
 *   sendet  rs:warenkorb:hinzugefuegt  vom Knopf aus (Kaufknopf, auch für den Knopf im Bambus-Produktblatt,
 *                                      Kaufleiste, Abschluss), bubbles; detail: { landung: Promise|null, items, antwort,
 *                                      quelle, farbe, auswahl }. rs-cart.js legt detail.geoeffnet (Promise) an;
 *                                      der Knopf bleibt gesperrt, bis es erfüllt ist (E-23), höchstens 8 s.
 *                                      Ohne Warenkorb-Schicht (kein window.RSWarenkorb) führt der Knopf nach dem
 *                                      Hinzufügen zur Warenkorbseite (Ladezeit-Runde 03.10.2026, A1)
 *   hört    rs:buybox:setzen           detail: { modus, farbe (1|2|'schwarz'), groesse1, groesse2, fokus }; zusatz
 *                                      wirkt nie (das Set wählt allein das sichtbare Häkchen, § 312a Abs. 3 BGB)
 *   hört    rs:warenkorb:geaendert     detail.anzahl (auch item_count, cart.item_count) und detail.korb (Bambus-Zeile);
 *                                      sonst /cart.js
 *   hört    rs:warenkorb:geoeffnet, rs:warenkorb:geschlossen (Kaufleiste)
 * Seit E-178 ohne „Schon im Warenkorb“ und ohne dessen Link; rs:warenkorb:oeffnen sendet dieses Modul nicht mehr.
 */

const GROESSEN = [20, 24, 28];

let D = null;
let kb = null;
let abschluesse = [];
let leiste = null;
let lauf = null;
// Gegenprüfung 02.10.2026: wahr, sobald starten die Galerie übernommen hat (galerieBeobachten)
let galerieGestartet = false;
// Ladezeit Runde 3 (12.10.2026): wahr, sobald jemand die Spur gescrollt hat (Wischen, Tastatur, Wiederherstellen); bis
// dahin steht sie auf Bild 1, und der erste Lauf von galerieNeu muss dafür kein Layout lesen (siehe dort)
let spurBewegt = false;

/* ---------- Galerie ab Bild 2 bei Bedarf (Rückmeldung 02.10.2026, Ladezeit am Handy) ---------- */

// Späte Galeriebilder stehen in <noscript data-rs-slide-bild> (rs-kaufbuehne.liquid), die Bühne wartet mit
// data-rs-spaet und data-rs-src (rs-buehne.liquid, rs-buehne.js). innerHTML liest den Inhalt in beiden Fällen: als
// Text (Skripte an, der Normalfall) und als Elemente (Section über DOMParser eingesetzt).
function slideFrei(s) {
  if (!s) return;
  s.querySelectorAll('noscript[data-rs-slide-bild]').forEach((n) => {
    const t = document.createElement('template');
    t.innerHTML = n.innerHTML;
    n.replaceWith(t.content);
  });
  s.querySelectorAll('[data-rs-spaet]').forEach((el) => el.removeAttribute('data-rs-spaet'));
  s.querySelectorAll('img[data-rs-src]').forEach((img) => {
    if (img.hasAttribute('data-rs-srcset')) {
      img.srcset = img.getAttribute('data-rs-srcset');
      img.removeAttribute('data-rs-srcset');
    }
    img.src = img.getAttribute('data-rs-src');
    img.removeAttribute('data-rs-src');
  });
}
// Bilder einer Slide, auch solange sie wartet (aus dem noscript gelesen, in einer Vorlage, die nichts lädt)
function slideBilder(s) {
  const n = s.querySelector('noscript[data-rs-slide-bild]');
  if (!n) return s.querySelectorAll('img');
  const t = document.createElement('template');
  t.innerHTML = n.innerHTML;
  return t.content.querySelectorAll('img');
}
// Gegenprüfung 02.10.2026: Wer wischt oder mit der Tastatur in die Galerie kommt, bevor starten fertig ist,
// bekommt die Bilder trotzdem (scroll-snap wischt auch ohne Skript); scheitert der Start, gibt init alles frei.
// Ladezeit-Runde 03.10.2026 (C3): Ein Tippen allein (pointerdown) gibt nichts frei. Diese Hörer bleiben den ganzen
// Lauf über an der Galerie; mit pointerdown hätte jedes Antippen, etwa am Anfang eines senkrechten Wischens über
// das Bild, alle Bilder geholt.
function galerieFrueh(kaufbuehne, signal) {
  const spur = kaufbuehne ? kaufbuehne.querySelector('[data-rs-galerie-spur]') : null;
  if (spur) spur.addEventListener('scroll', () => { spurBewegt = true; }, { once: true, passive: true, signal });
  const alle = () => {
    if (spur) spur.querySelectorAll('[data-rs-slide]').forEach(slideFrei);
  };
  if (!spur || !spur.querySelector('noscript[data-rs-slide-bild], [data-rs-spaet]')) return alle;
  const galerie = spur.closest('[data-rs-galerie]') || spur;
  const opt = { once: true, passive: true, signal };
  spur.addEventListener('scroll', alle, opt);
  ['keydown', 'focusin'].forEach((typ) => galerie.addEventListener(typ, alle, opt));
  return alle;
}

// Start und Neustart: Im Theme-Editor rendert Shopify Sections neu, das Modul läuft aber nur einmal.
// Jeder Lauf hängt seine Listener an ein eigenes AbortController-Signal, der nächste Lauf löst sie.
async function init() {
  if (lauf) lauf.abort();
  lauf = new AbortController();
  const datenKnoten = document.querySelector('[data-rs-buybox-daten]');
  try {
    D = datenKnoten ? JSON.parse(datenKnoten.textContent) : null;
  } catch (e) {
    D = null;
  }
  kb = document.querySelector('[data-rs-kaufbuehne]');
  spurBewegt = false;
  const galerieNotfall = galerieFrueh(kb, lauf.signal);
  abschluesse = Array.from(document.querySelectorAll('[data-rs-abschluss]'));
  leiste = document.querySelector('[data-rs-kaufleiste]');
  if (!D || !kb) {
    if (kb) kb.removeAttribute('data-rs-vorlaeufig');
    galerieNotfall();
    // Ohne Kaufbühne kein Zustand: Auswahl im Abschluss ausblenden, Kaufleiste bleibt aus. Den Seitenmodus
    // (Ladezeit 01.10.2026) entfernen, sonst bliebe nach dem Entfernen der Kaufbühne im Theme-Editor der Einzel-Inhalt.
    if (!kb) document.documentElement.removeAttribute('data-rs-seitenmodus');
    abschluesse.forEach((a) => {
      const aus = a.querySelector('[data-rs-ab-auswahl]');
      if (aus) aus.hidden = true;
    });
    return;
  }
  galerieGestartet = false;
  try {
    await starten(lauf.signal);
  } finally {
    // Gegenprüfung 02.10.2026: Endet starten vor der Galerie (Fehler, Abbruch), alle Bilder freigeben
    if (!galerieGestartet) galerieNotfall();
    // Früher Tipp (02.10.2026): Vorläufige Werte nie stehen lassen, auch wenn starten früh endet oder wirft
    kb.removeAttribute('data-rs-vorlaeufig');
  }
}

await init();
document.addEventListener('shopify:section:load', () => {
  init();
});

async function starten(signal) {
  const T = D.texte || {};
  const P = await preiseLaden();
  // Neustart im Theme-Editor, während die Preise luden: dieser Lauf ist überholt (JS-13)
  if (signal && signal.aborted) return;
  let RSFlug = null;

  const form = kb.querySelector('[data-rs-buybox-form]');
  const kaufKnopf = form ? form.querySelector('[data-rs-kaufen]') : null;
  const ansageEl = kb.querySelector('[data-rs-ansage]');
  // Bambus-Zeile (13.10.2026, ändert E-178): Hülle der Häkchen-Zeile über dem Kaufknopf, Startstand aus Liquid (Warenkorb
  // beim Laden). Legt der Knopf im Produktblatt dazu, zeigt der Kaufknopf direkt unter der Zeile Rad und Ladetext
  // (bambusDazu); bambusAusloeser („Details“ der Zeile) springt nur ohne Kaufknopf ein (der Knopf im geschlossenen
  // Blatt ist unsichtbar)
  const bambusEl = D.bambus ? kb.querySelector('[data-rs-bambus]') : null;
  const bambusAusloeser = bambusEl ? bambusEl.querySelector('.rs-zusatz-zeile__details') : null;
  // Runde 24: Produktblatt (rs-bambus-blatt.liquid) mit eigenem Knopf und Satz; bambusZeichnen führt beide nach
  // Runde 24b: die Fenster der Kacheln tragen ebenfalls data-rs-blatt, sie zählen hier nicht
  const bambusBlatt = bambusEl ? kb.querySelector('[data-rs-blatt]:not([data-rs-kachel-fenster])') : null;
  const bambusBlattKnopf = bambusBlatt ? bambusBlatt.querySelector('[data-rs-bambus-blatt-dazu]') : null;
  const pfannenProdukte = (Array.isArray(D.pfannen) ? D.pfannen : []).map(Number);
  let pfanneImKorb = !!bambusEl && bambusEl.getAttribute('data-rs-bambus-pfanne') === 'true';
  let bambusImKorb = !!bambusEl && bambusEl.hidden;
  const z = {
    modus: D.start.modus,
    farbe: Number(D.start.farbe) === 2 ? 2 : 1,
    groesse1: Number(D.start.groesse1) || 24,
    groesse2: Number(D.start.groesse2) || 28,
    zusatz: false
  };
  let anzahl = Number(D.anzahl) || 0;
  let laeuft = false;

  // Listener an document und window hängen am Signal dieses Laufs (Neustart im Theme-Editor)
  const an = (ziel, typ, fn, opt) =>
    ziel.addEventListener(typ, fn, Object.assign({ signal }, typeof opt === 'boolean' ? { capture: opt } : opt || {}));

  // Rückmeldung 02.10.2026 (Ladezeit am Handy): rs-flug.js erst bei der ersten Eingabe (Zeigen, Tippen, Tastatur)
  // oder im Leerlauf nach load; geflogen wird erst nach dem Tippen auf „In den Warenkorb“. Fehlt das Modul dann
  // noch, landet die Pfanne ohne Flug im Warenkorb wie bei reduzierter Bewegung.
  let flugGeholt = false;
  const flugLaden = () => {
    if (flugGeholt || !D.flugUrl) return;
    flugGeholt = true;
    import(modulUrl(D.flugUrl))
      .then((m) => {
        RSFlug = m && (m.starte ? m : m.default);
      })
      .catch(() => {
        RSFlug = window.RSFlug || null;
      });
  };
  ['pointerdown', 'touchstart', 'keydown'].forEach((typ) => an(window, typ, flugLaden, { once: true, passive: true }));
  const flugImLeerlauf = () => {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(flugLaden, { timeout: 5000 });
    else window.setTimeout(flugLaden, 3000);
  };
  if (document.readyState === 'complete') flugImLeerlauf();
  else an(window, 'load', flugImLeerlauf, { once: true });

  /* Die Bewertungszeile hat seit der Kaufseite Runde 2 (E-139) kein ⓘ mehr: Sie ist ein Link mit Sternchen auf
     das Bewertungsband, dort steht der Pflicht-Hinweis offen. Kein Skript nötig. */

  /* ---------- Hilfen ---------- */

  const ruhig = () =>
    D.bewegung === false ||
    document.documentElement.classList.contains('ohne-bewegung') ||
    !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const muster = (t, w) => String(t || '').replace(/\{(\w+)\}/g, (m, k) => (k in w ? w[k] : m));
  const euro = (c) => {
    if (c == null) return '';
    if (P && typeof P.formatEuro === 'function') return P.formatEuro(c);
    // Rückfall ohne rs-preise.js: dasselbe Format „72,99 €“ mit geschütztem Leerzeichen
    const v = Math.round(c);
    return String(Math.floor(v / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + String(v % 100).padStart(2, '0') + '\u00a0€';
  };
  // Zwischen Zahl und „cm“ steht immer ein geschütztes Leerzeichen, auch in Texten aus den Settings
  const NBSP = '\u00a0';
  const mitCm = (s) => String(s == null ? '' : s).replace(/(\d) cm\b/g, '$1' + NBSP + 'cm');
  const held = (g) => (D.held[g] || '') + ', ' + g + NBSP + 'cm';
  const farbName = (f) => (D.farben[f] ? D.farben[f].name : '');
  const paar = () => [Math.min(z.groesse1, z.groesse2), Math.max(z.groesse1, z.groesse2)];
  const daten = { prozent: D.prozent, schwelle: D.schwelle, einzel: D.einzel, set: D.set, bambus: D.bambus, duoVarianten: D.duoVarianten || {} };
  const hatEinzel = ['1', '2'].some((f) => D.einzel && D.einzel[f] && GROESSEN.some((g) => D.einzel[f][g]));
  const hatSet = !!(D.set && (D.set['1'] || D.set['2']));
  const modusMoeglich = (m) => (m === 'set' ? hatSet : m === 'eine' || m === 'zwei' ? hatEinzel : false);
  const erster = (s) => {
    const i = String(s || '').indexOf('. ');
    return i > 0 ? s.slice(0, i + 1) : s;
  };

  // Bestand (Rückmeldung 25.09.2026): Ausverkauftes ist nicht wählbar und nicht kaufbar, ohne Zahlen,
  // ohne Knappheit. Rechnung in rs-preise.js (wahlMoeglich, wahlKorrigieren); fehlt das Modul, bleibt
  // die Auswahl wählbar und der Knopf sperrt wie bisher bei nicht lieferbarer Auswahl.
  function moeglich(f) {
    if (P && typeof P.wahlMoeglich === 'function') return P.wahlMoeglich(daten, f);
    return null;
  }

  function korrigieren() {
    if (!P || typeof P.wahlKorrigieren !== 'function') return false;
    const n = P.wahlKorrigieren(z, daten);
    z.modus = n.modus;
    z.farbe = n.farbe;
    z.groesse1 = n.groesse1;
    z.groesse2 = n.groesse2;
    z.zusatz = !!n.zusatz;
    return !!n.geaendert;
  }

  function rechne(w) {
    const wahl = w || z;
    if (P && typeof P.preisDerWahl === 'function') return P.preisDerWahl(wahl, daten);
    return lokalPreisDerWahl(wahl);
  }

  function karten(f) {
    if (P && typeof P.buyboxKarten === 'function') return P.buyboxKarten(daten, f);
    return lokalKarten(f);
  }

  // E-168/E-169: Vergleich für „einzeln …“ neben dem Preis und die Plakette (rs-preise.js vergleichDerWahl), ohne Modul lokal
  function vergleichWahl(w = z) {
    if (P && typeof P.vergleichDerWahl === 'function') return P.vergleichDerWahl(w, daten);
    return lokalVergleichDerWahl(w);
  }

  function groessenListe() {
    if (z.modus === 'set') return [20, 24, 28];
    if (z.modus === 'eine') return [z.groesse1];
    return paar();
  }

  function groessenNamen() {
    if (z.modus === 'set') return held(20) + ', ' + held(24) + ', und ' + held(28);
    if (z.modus === 'eine') return held(z.groesse1);
    const [a, b] = paar();
    return a === b ? 'zweimal ' + held(a) : held(a) + ', und ' + held(b);
  }

  function groessteGroesse() {
    if (z.modus === 'set') return 28;
    if (z.modus === 'eine') return z.groesse1;
    return Math.max(z.groesse1, z.groesse2);
  }

  // Duo 20 % (01.10.2026): Ersparnis des gewählten Paars in der gewählten Farbe als Pfannen-Duo, in Cent (rs-preise.js
  // zweierPaar, ohne Modul duoPaar). Nur mit kaufbarem Pfannen-Duo, lieferbaren Einzelpfannen (07 3.3) und Nachlass über 0,
  // sonst null: Für ein gesperrtes Paar steht kein „Für beide …“ und kein „du sparst …“.
  function zweierErsparnis() {
    const pz = P && typeof P.zweierPaar === 'function' ? P.zweierPaar(daten, z.farbe, z.groesse1, z.groesse2) : duoPaar(z.farbe, z.groesse1, z.groesse2);
    return pz && pz.kaufbar && pz.einzelnLieferbar && pz.ersparnis > 0 ? pz.ersparnis : null;
  }

  // Duo 20 % (02.10.2026, Preisspalte): größte Ersparnis unter den kaufbaren Pfannen-Duos einer Farbe in Cent, 0 ohne
  // Paar. Wache für das Abzeichen „Größte Ersparnis“ am Set, gleiche Rechnung wie rs-kaufbuehne.liquid (zwei_spar_max);
  // mit rs-preise.js über zweierPaar, ohne Modul über duoPaar
  function zweiSparMax(f) {
    let max = 0;
    GROESSEN.forEach((a, i) => {
      GROESSEN.slice(i).forEach((b) => {
        const pz = P && typeof P.zweierPaar === 'function' ? P.zweierPaar(daten, f, a, b) : duoPaar(f, a, b);
        if (pz && pz.kaufbar && pz.ersparnis > max) max = pz.ersparnis;
      });
    });
    return max;
  }

  // Duo 20 % (02.10.2026, Preisspalte, Denny): das gewählte Paar als Pfannen-Duo (rs-preise.js zweierPaar, ohne Modul
  // duoPaar), nur beim Zweier und nur, wenn es kaufbar ist; sonst null. Für die Spalte der Karte „2x“ (ansichtZeichnen),
  // gleiche Regel in rs-kaufbuehne.liquid (kp_zwei_paar)
  function gewaehltesPaar(wahl) {
    if (!wahl || wahl.modus !== 'zwei') return null;
    const pz = P && typeof P.zweierPaar === 'function' ? P.zweierPaar(daten, wahl.farbe, wahl.groesse1, wahl.groesse2) : duoPaar(wahl.farbe, wahl.groesse1, wahl.groesse2);
    return pz && pz.kaufbar ? pz : null;
  }

  // Einzelpreise der zwei gewählten Größen zusammen, in Cent (Vergleichswert nach E-62)
  function zweierEinzeln() {
    const ef = (D.einzel && D.einzel[String(z.farbe)]) || {};
    const a = ef[z.groesse1] || ef[String(z.groesse1)];
    const b = ef[z.groesse2] || ef[String(z.groesse2)];
    return a && b ? a.preis + b.preis : null;
  }

  // „Einzeln zusammen {einzeln}, du sparst {ersparnis}“ (Set-Karte, Abschluss); fett nur „du sparst …“ (E-62)
  // Duo 20 % (01.10.2026): Zweier-Karte „20 % auf beide“ wie rs-kaufbuehne.liquid (karte_zwei_preis, {rabatt} in Prozent,
  // das „%“ steht im Text); „du sparst …“ dahinter nur, wenn karte_zwei_sparen gefüllt ist (seit E-185 leer). Die
  // Entität &nbsp; vor „%“ und „€“ wie in Liquid, damit beim Laden nichts neu geschrieben wird. Seit Prüfung Preislogik B2
  // (02.10.2026) nur für eine Farbe mit kaufbarem Pfannen-Duo (ansichtZeichnen, k.zwei.ab)
  function zweiInfoHTML(ersparnis) {
    const p = Number(D.prozent);
    if (!(p > 0)) return '';
    // Denny, 30.09.2026: die Ersparnis fett und grün wie „du sparst …“ beim Set (gleiche Ausgabe in rs-kaufbuehne.liquid)
    let html = '<strong>' + esc(muster(T.karteZwei, { rabatt: p })).replace(/ (%|€)/g, '&nbsp;$1') + '</strong>';
    if (ersparnis > 0 && String(T.karteZweiSparen || '').trim()) {
      html += ', <strong>' + esc(muster(T.karteZweiSparen, { ersparnis: euro(ersparnis) })) + '</strong>';
    }
    return html.replace(/\u00a0/g, '&nbsp;');
  }

  // Duo 20 % (02.10.2026, Preisspalte): Zeilen rechts unter dem Preis der Karten „2x“ und „3x“, „einzeln …“
  // (T.karteEinzeln mit {einzeln}) und „Du sparst …“ (T.karteSparen mit {ersparnis}); beim Zweier steht „ab“ (ab) vor dem
  // Betrag. Gleiche Ausgabe wie rs-kaufbuehne.liquid (kp_einzeln_*, kp_sparen_*): Text maskiert, jeder Platzhalter
  // ersetzt, &nbsp; vor „€“, damit beim Laden nichts neu geschrieben wird. Ohne Text oder Betrag leer.
  function kartenZeile(tpl, platzhalter, ab, cent) {
    const t = String(tpl == null ? '' : tpl).trim();
    if (!t || cent == null) return '';
    const vor = String(ab == null ? '' : ab).trim();
    const betrag = (vor ? esc(vor) + ' ' : '') + esc(euro(cent));
    return esc(t).split('{' + platzhalter + '}').join(betrag).replace(/\u00a0/g, '&nbsp;');
  }

  function vergleichHTML(tpl, einzeln, ersparnis) {
    return esc(tpl)
      .replace('du sparst {ersparnis}', '<strong>du sparst {ersparnis}</strong>')
      .replace('Du sparst {ersparnis}', '<strong>Du sparst {ersparnis}</strong>')
      .replace('{einzeln}', esc(euro(einzeln)))
      .replace('{ersparnis}', esc(euro(ersparnis)));
  }

  // E-169 (Denny, 29.09.2026): Zeile 3 nennt nur „Gesamtpreis“ vor „inkl. MwSt.“ und dem Versand, ohne die Auswahl
  // (vorher E-153, B5). Die Auswahl nennen die Karten und die Ansage (ansageText). Gleiche Regel in
  // rs-kaufbuehne.liquid (pl_text).
  function preisLabel() {
    return mitCm(String(T.preisLabel || '').trim());
  }

  // E-169: „einzeln {einzeln}“ neben dem Preis (zeile) und die Plakette dahinter als reiner Text, gleiche Ausgabe wie
  // rs-kaufbuehne.liquid (pz_zeile, pz_plakette). Liquid schreibt vor „€“ und „%“ ein &nbsp;, hier steht U+00A0: Der Text
  // ist beim Laden gleich, nichts wird neu geschrieben. Seit E-170 Zweier und Set „Du sparst {ersparnis}“ ({rabatt} bleibt
  // möglich, seit Duo 20 % (01.10.2026) in Prozent); {einzeln} sind die vollen Einzelpreise, mit Zusatz samt Bambus. Ohne
  // Vergleich bleibt beides leer.
  function preisZusatz(vz) {
    if (!vz) return { plakette: '', zeile: '' };
    const set = vz.art === 'set';
    const ersparnis = euro(vz.ersparnis);
    const plakette = set
      ? muster(T.plaketteSet, { ersparnis })
      : muster(T.plaketteZwei, { rabatt: vz.prozent, ersparnis }).replace(/ (%|€)/g, NBSP + '$1');
    return { plakette, zeile: muster(set ? T.zeileSet : T.zeileZwei, { einzeln: euro(vz.einzeln) }) };
  }

  // Duo 20 % (01.10.2026): Ist beim Zweier das Paar gesperrt (Duo-Variante fehlt, nicht lieferbar oder Preis passt nicht
  // zur Rechnung, rechne().sperre), nennt die Zeile über dem Knopf die Kombination in der Farbe (zweier_gesperrt), sonst
  // steht der allgemeine Text. Gleiche Regel in rs-kaufbuehne.liquid (nl_text)
  function nichtLieferbarText(r) {
    if (z.modus === 'zwei' && r && r.sperre && String(T.zweierGesperrt || '').trim()) return muster(T.zweierGesperrt, { farbe: farbName(z.farbe) });
    return T.nichtLieferbar || '';
  }

  // Sofort scrollen, auch wenn Shrine html auf scroll-behavior: smooth setzt (Runde 4, A2)
  function springen(dy) {
    const h = document.documentElement;
    const alt = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    window.scrollBy(0, dy);
    h.style.scrollBehavior = alt;
  }

  function versandHTML(summe) {
    const frei = summe >= D.schwelle;
    const link = (html) => (D.versandUrl ? '<a href="' + esc(D.versandUrl) + '">' + html + '</a>' : html);
    // PayPal bei jeder Pfanne (Denny, 30.09.2026, Weg A aus 08 2.16): unter der Schwelle steht der Betrag aus
    // rs_versand_kosten am Preis, „zzgl. 4,90 € Versand“; gleicher Text in rs-preis.liquid (betrag: true)
    const betrag = String(D.versandKosten || '').trim();
    const kosten = (betrag ? esc(betrag).replace(/\s*€/, '&nbsp;€') + ' ' : '') + esc(T.versandKosten);
    return esc(D.steuer) + ', ' + (frei ? link(esc(T.versandFrei)) : 'zzgl. ' + link(kosten));
  }

  function vorlage(name) {
    const t = kb.querySelector('template[data-rs-tpl="' + name + '"]');
    return t ? t.content : null;
  }

  function setzeHTML(wurzel, sel, html) {
    wurzel.querySelectorAll(sel).forEach((el) => {
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function setzeText(wurzel, sel, text) {
    wurzel.querySelectorAll(sel).forEach((el) => {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  /* ---------- Start: URL-Parameter (03 2.4) ---------- */

  function farbNr(wert) {
    if (wert === 1 || wert === 2) return wert;
    const s = String(wert || '').toLowerCase();
    if (s === '1' || s === '2') return Number(s);
    const nr = ['1', '2'].find((n) => D.farben[n] && D.farben[n].kurz === s);
    return nr ? Number(nr) : null;
  }

  (function urlAnwenden() {
    const q = new URLSearchParams(window.location.search);
    const a = q.get('auswahl');
    const g = q.get('groesse');
    const f = q.get('farbe');
    if (a && modusMoeglich(a)) {
      z.modus = a;
      if (a === 'eine') {
        z.groesse1 = 24;
        if (g && GROESSEN.includes(Number(g))) z.groesse1 = Number(g);
      } else if (a === 'zwei') {
        z.groesse1 = 24;
        z.groesse2 = 28;
        const t = String(g || '').split('-').map(Number);
        if (t.length === 2 && t.every((x) => GROESSEN.includes(x))) {
          z.groesse1 = t[0];
          z.groesse2 = t[1];
        }
      }
    }
    if (f) {
      const nr = farbNr(f);
      if (nr && D.farben[nr] && D.farben[nr].da) z.farbe = nr;
    }
    if (!modusMoeglich(z.modus)) z.modus = hatSet ? 'set' : 'zwei';
    // Ist die Auswahl in dieser Farbe nicht lieferbar, in der anderen aber schon: andere Farbe (03 2.4)
    const jetzt = rechne();
    if (!jetzt || !jetzt.verfuegbar) {
      const andere = z.farbe === 1 ? 2 : 1;
      const dort = rechne(Object.assign({}, z, { farbe: andere }));
      if (dort && dort.verfuegbar && D.farben[andere] && D.farben[andere].da) z.farbe = andere;
    }
    // Danach Modus und Größen an den Bestand anpassen (nächste bestellbare Größe)
    korrigieren();
  })();

  // Früher Tipp (02.10.2026, F1): Was der Kunde vor dem Start angetippt hat (data-rs-beruehrt, vom Skript hinter dem
  // Kaufformular), gilt jetzt, sofern es wählbar ist; ein Moduswechsel belegt die Größen vor wie der change-Handler (E-28).
  // Danach der Bestand wie beim Start (korrigieren).
  const beruehrt = form ? String(form.getAttribute('data-rs-beruehrt') || '').split(',').filter(Boolean) : [];
  if (beruehrt.length) {
    const wert = (feld) => {
      const inp = form.querySelector('input[data-rs-feld="' + feld + '"]:checked');
      return inp ? inp.value : null;
    };
    if (beruehrt.includes('farbe')) {
      const nr = farbNr(wert('farbe'));
      if (nr && D.farben[nr] && D.farben[nr].da) z.farbe = nr;
    }
    if (beruehrt.includes('modus')) {
      const m = wert('modus');
      if (m && m !== z.modus && modusMoeglich(m)) {
        z.modus = m;
        if (m === 'eine') z.groesse1 = 24;
        if (m === 'zwei') {
          z.groesse1 = 24;
          z.groesse2 = 28;
        }
      }
    }
    const groesse = (feld) => {
      const n = Number(wert(feld));
      return GROESSEN.includes(n) ? n : null;
    };
    if (z.modus === 'eine' && beruehrt.includes('g') && groesse('g')) z.groesse1 = groesse('g');
    if (z.modus === 'zwei' && beruehrt.includes('z1') && groesse('z1')) z.groesse1 = groesse('z1');
    if (z.modus === 'zwei' && beruehrt.includes('z2') && groesse('z2')) z.groesse2 = groesse('z2');
    // Bambus-Zeile (13.10.2026): ein vor dem Start gesetztes Häkchen gilt, sonst nähme der erste Zeichenlauf es still
    // zurück; nie bei Bambus im Warenkorb (die Zeile ist dann verborgen)
    if (beruehrt.includes('zusatz')) {
      const zf = form.querySelector('input[data-rs-feld="zusatz"]');
      z.zusatz = !!(zf && zf.checked) && !bambusImKorb;
    }
    korrigieren();
  }

  /* ---------- Ansichten: Buybox und Abschluss ---------- */

  const ansichten = [];
  if (form) {
    ansichten.push({
      art: 'buybox',
      wurzel: kb,
      felder: form,
      ab: T.ab,
      vergleichKarte: T.vergleichKarte,
      vergleich: T.vergleich,
      knopf: kaufKnopf,
      knopfText: T.knopf
    });
  }
  abschluesse.forEach((a) => {
    const felder = a.querySelector('[data-rs-ab-auswahl]');
    if (!felder) return;
    const knopf = felder.querySelector('[data-rs-kaufen]');
    const textEl = knopf ? knopf.querySelector('[data-rs-kaufen-text]') : null;
    ansichten.push({
      art: 'abschluss',
      wurzel: a,
      felder,
      ab: a.dataset.rsTAb || T.ab,
      vergleichKarte: a.dataset.rsTVergleichKarte || T.vergleichKarte,
      vergleich: a.dataset.rsTVergleich || T.vergleich,
      groessen: { set: a.dataset.rsTGroessenSet, eine: a.dataset.rsTGroessenEine, zwei: a.dataset.rsTGroessenZwei },
      knopf,
      knopfText: textEl ? textEl.textContent.trim() : T.knopf
    });
  });

  function ansichtZeichnen(v, r, verf, k) {
    const w = v.wurzel;
    w.dataset.rsFarbe = String(z.farbe);
    // Sichtpruefung 25.09.2026: Farbe auch fuer Sektionen ausserhalb der Kaufbuehne (Lieferumfang, Unterseite).
    // Rückmeldung 02.10.2026 (Ladezeit am Handy): nur bei echter Änderung, jedes Schreiben an html rechnet alle Stile
    if (document.documentElement.getAttribute('data-rs-seitenfarbe') !== String(z.farbe)) {
      document.documentElement.setAttribute('data-rs-seitenfarbe', String(z.farbe));
    }
    w.dataset.rsModus = z.modus;
    // Ladezeit 01.10.2026: Lieferumfang in RS Details folgt der Kaufbühne über html[data-rs-seitenmodus] statt
    // html:has(.rs-kb[data-rs-modus]); nur die Kaufbühne zählt, nicht der Abschluss, und nur bei echter Änderung.
    if (v.art === 'buybox' && document.documentElement.getAttribute('data-rs-seitenmodus') !== z.modus) {
      document.documentElement.setAttribute('data-rs-seitenmodus', z.modus);
    }
    v.felder.querySelectorAll('[data-rs-feld]').forEach((inp) => {
      const f = inp.dataset.rsFeld;
      if (f === 'farbe') inp.checked = Number(inp.value) === z.farbe;
      else if (f === 'modus') inp.checked = inp.value === z.modus;
      else if (f === 'g' || f === 'z1') inp.checked = Number(inp.value) === z.groesse1;
      else if (f === 'z2') inp.checked = Number(inp.value) === z.groesse2;
      else if (f === 'zusatz') inp.checked = z.zusatz;
      // Clarity (18.10.2026, Aufnahme mit drei Haken): Die Aufnahme kennt nur Attribute und angetippte Felder. Was dieses
      // Skript per Eigenschaft umschaltet, sieht sie nicht; die Liquid-Vorwahl (checked) blieb im Abspielen stehen und
      // zeigte über :has(input:checked) einen zweiten Haken. Das Attribut folgt deshalb dem Zustand, nur bei Änderung.
      // Für Kunden wirkungslos: nach dem Setzen der Eigenschaft ändert das Attribut die Auswahl nicht mehr.
      if (inp.hasAttribute('checked') !== inp.checked) inp.toggleAttribute('checked', inp.checked);
    });
    v.felder.querySelectorAll('.rs-farbe, .rs-option, .rs-segment, .rs-zusatz-zeile').forEach((l) => {
      const i = l.querySelector('input');
      l.classList.toggle('ist-gewaehlt', !!(i && i.checked));
    });
    // Karte „Wie viele“: gewählt, wenn ihr Kopf gewählt ist (die Größenwahl liegt in derselben Karte)
    v.felder.querySelectorAll('.rs-karte').forEach((k) => {
      const i = k.querySelector(':scope > .rs-option input');
      k.classList.toggle('ist-gewaehlt', !!(i && i.checked));
    });
    w.querySelectorAll('[data-rs-groessen]').forEach((el) => {
      el.hidden = el.dataset.rsGroessen !== z.modus;
    });
    setzeText(w, '[data-rs-farbe-wert]', ': ' + farbName(z.farbe));
    w.querySelectorAll('[data-rs-farbtext]').forEach((el) => {
      el.hidden = Number(el.dataset.rsFarbtext) !== z.farbe;
    });
    setzeText(w, '[data-rs-zweier-name="1"]', held(z.groesse1));
    setzeText(w, '[data-rs-zweier-name="2"]', held(z.groesse2));

    // Rückmeldung 02.10.2026: Der Satz „Für beide …, du sparst …“ unter den Größen ist entfallen (steht im Kopf der Karte
    // „2x“); zweierErsparnis und zweierEinzeln bleiben für die Ansage (ansageText)
    // Aufklapper „Alle sechs Kombinationen“ (Kritik 26.09.2026): Beträge der gewählten Farbe, von Liquid
    // für beide Farben vorgerechnet; eine Zeile ohne Betrag entfällt
    w.querySelectorAll('[data-rs-zw-zeile]').forEach((zeile) => {
      let voll = true;
      zeile.querySelectorAll('[data-rs-zw-b1]').forEach((el) => {
        const t = el.getAttribute('data-rs-zw-b' + z.farbe) || '';
        if (el.textContent !== t) el.textContent = t;
        if (!t) voll = false;
      });
      zeile.hidden = !voll;
    });

    // Karten der gewählten Farbe (E-54, E-62)
    setzeHTML(w, '[data-rs-karte-preis="eine"]', k.eine.ab != null ? esc(v.ab) + ' ' + esc(euro(k.eine.ab)) : '');
    // Runde 4 (E-153, B10): der kleinste Zweier-Betrag rechts im Kopf wie bei den anderen Karten. Duo 20 % (02.10.2026,
    // Preisspalte, Denny): ist „2x“ in der Kaufbühne gewählt und das gewählte Paar kaufbar, dessen Duo-Preis ohne „ab“
    // (gewaehltesPaar, bei jedem Neuzeichnen: Modus, Größe, Farbe); gesperrt, nicht gewählt und im Abschluss „ab …“
    const gp = v.art === 'buybox' ? gewaehltesPaar(z) : null;
    setzeHTML(w, '[data-rs-karte-preis="zwei"]', gp ? esc(euro(gp.summe)) : k.zwei.ab != null ? esc(v.ab) + ' ' + esc(euro(k.zwei.ab)) : '');
    // E-171: immer neu setzen. Prüfung Preislogik B2 (02.10.2026): „20 % auf beide“ nur mit kaufbarem Pfannen-Duo in der
    // gewählten Farbe (k.zwei.ab) wie Liquid (ab_zwei); beim Farbwechsel kommt die Zeile mit oder geht
    setzeHTML(w, '[data-rs-karte-spar="zwei"]', k.zwei.ab != null ? zweiInfoHTML(k.zwei.ersparnisAb) : '');
    // Duo 20 % (02.10.2026, Preisspalte): rechts unter „ab …“ die Zeilen „einzeln ab …“ (die zwei Pfannen des günstigsten
    // kaufbaren Pfannen-Duos einzeln, k.zwei.ab plus k.zwei.ersparnisAb, ungestrichen) und „Du sparst ab …“, nur mit
    // kaufbarem Pfannen-Duo in der gewählten Farbe und echter Ersparnis, wie Liquid (kp_einzeln_zwei, kp_sparen_zwei);
    // „Du sparst“ nie ohne „einzeln …“ (E-170). Leere Felder blendet rs-kaufbuehne.css aus (:empty).
    // Gewählt und kaufbar (gp, Denny 02.10.2026): die Werte dieses Paars ohne „ab“, „einzeln …“ (beide Einzelpreise der
    // Farbe) und „Du sparst …“ wie der Preisblock nur mit lieferbaren Einzelpfannen und echter Ersparnis (Liquid: kp_zwei_paar)
    let zweiEinzeln = '';
    let zweiSparen = '';
    if (gp) {
      if (gp.einzelnLieferbar && gp.ersparnis > 0) {
        zweiEinzeln = kartenZeile(T.karteEinzeln, 'einzeln', '', gp.einzeln);
        if (zweiEinzeln) zweiSparen = kartenZeile(T.karteSparen, 'ersparnis', '', gp.ersparnis);
      }
    } else if (k.zwei.ab != null && k.zwei.ersparnisAb > 0) {
      zweiEinzeln = kartenZeile(T.karteEinzeln, 'einzeln', v.ab, k.zwei.ab + k.zwei.ersparnisAb);
      if (zweiEinzeln) zweiSparen = kartenZeile(T.karteSparen, 'ersparnis', v.ab, k.zwei.ersparnisAb);
    }
    setzeHTML(w, '[data-rs-karte-einzeln="zwei"]', zweiEinzeln);
    setzeHTML(w, '[data-rs-karte-sparen="zwei"]', zweiSparen);
    setzeHTML(w, '[data-rs-karte-preis="set"]', k.set.preis != null ? esc(euro(k.set.preis)) : '');
    // E-169 (Denny, 29.09.2026): Das Set wird mit den drei vollen Einzelpreisen verglichen (rs-preise.js setErsparnis),
    // seit E-184 auf Dennys Entscheidung trotz Paar-Regel; gleiche Rechnung wie in Liquid (set_einzeln)
    const sv = k.set.vergleich;
    // Seit Duo 20 % (02.10.2026, Preisspalte) trägt data-rs-karte-info="set" nur der Abschluss (rs-abschluss.liquid); die
    // Set-Karte der Kaufbühne nennt den Vergleich rechts unter dem Preis wie die Karte „2x“ (kp_einzeln_set, kp_sparen_set)
    setzeHTML(w, '[data-rs-karte-info="set"]', sv ? vergleichHTML(v.vergleichKarte, sv.einzelnSumme, sv.ersparnis) : '');
    const setEinzeln = sv ? kartenZeile(T.karteEinzeln, 'einzeln', '', sv.einzelnSumme) : '';
    setzeHTML(w, '[data-rs-karte-einzeln="set"]', setEinzeln);
    setzeHTML(w, '[data-rs-karte-sparen="set"]', setEinzeln ? kartenZeile(T.karteSparen, 'ersparnis', '', sv.ersparnis) : '');
    w.querySelectorAll('[data-rs-karte-prozent]').forEach((el) => {
      el.hidden = !sv;
      if (sv) el.textContent = muster(T.prozent, { prozent: sv.prozent });
    });
    // E-178, seit Duo 20 % (02.10.2026, Preisspalte) zwei Abzeichen, getrennt gesteuert: am Set „Größte Ersparnis“ nur, wenn
    // das Set mehr spart als jedes kaufbare Pfannen-Duo der Farbe (wie Liquid zwei_spar_max), an „2x“ „Unser Tipp“ nur mit
    // kaufbarem Pfannen-Duo (k.zwei.ab, wie Liquid zwei_da)
    const setAbzeichen = !!sv && sv.ersparnis > zweiSparMax(z.farbe);
    w.querySelectorAll('[data-rs-karte-abzeichen="set"]').forEach((el) => {
      if (el.hidden !== !setAbzeichen) el.hidden = !setAbzeichen;
    });
    w.querySelectorAll('[data-rs-karte-abzeichen="zwei"]').forEach((el) => {
      const aus = k.zwei.ab == null;
      if (el.hidden !== aus) el.hidden = aus;
    });
    w.querySelectorAll('[data-rs-karte-status="set"]').forEach((el) => {
      el.hidden = k.set.preis == null || k.set.verfuegbar;
    });
    // Duo 20 % (01.10.2026): „Zwei Pfannen“ folgt den kaufbaren Pfannen-Duos (k.zwei.ab), nicht den Einzelpfannen
    w.querySelectorAll('[data-rs-karte-status="eine"]').forEach((el) => {
      el.hidden = k.eine.ab != null;
    });
    w.querySelectorAll('[data-rs-karte-status="zwei"]').forEach((el) => {
      el.hidden = k.zwei.ab != null;
    });

    // Lieferbarkeit je Farbe und je Größe (E-40: wählbar, mit Zusatz)
    [1, 2].forEach((f) => {
      const rf = rechne(Object.assign({}, z, { farbe: f }));
      w.querySelectorAll('[data-rs-farbe-status="' + f + '"]').forEach((el) => {
        el.hidden = !!(rf && rf.verfuegbar);
      });
    });
    const ef = (D.einzel && D.einzel[String(z.farbe)]) || {};
    GROESSEN.forEach((g) => {
      const e = ef[g] || ef[String(g)];
      setzeHTML(w, '[data-rs-groesse-preis="' + g + '"]', e ? esc(euro(e.preis)) : '');
      w.querySelectorAll('[data-rs-groesse-status="' + g + '"], [data-rs-segment-status="' + g + '"]').forEach((el) => {
        el.hidden = !!(e && e.verfuegbar);
      });
    });

    // Bestand: nicht wählbar machen, was ausverkauft ist (Rückmeldung 25.09.2026). Farbe nur, wenn in
    // ihr gar nichts geht; wählt jemand eine Farbe, passt korrigieren() Modus und Größen an.
    const mAkt = moeglich(z.farbe);
    if (mAkt) {
      const mFarbe = { 1: moeglich(1), 2: moeglich(2) };
      v.felder.querySelectorAll('[data-rs-feld]').forEach((inp) => {
        const feld = inp.dataset.rsFeld;
        let aus;
        if (feld === 'farbe') aus = !(mFarbe[Number(inp.value)] && mFarbe[Number(inp.value)].farbe);
        else if (feld === 'modus') aus = !mAkt[inp.value];
        else if (feld === 'g' || feld === 'z1' || feld === 'z2') aus = !mAkt.groessen[Number(inp.value)];
        else return;
        if (inp.disabled !== aus) inp.disabled = aus;
        const karte = inp.closest('.rs-farbe, .rs-option, .rs-segment');
        if (karte) karte.classList.toggle('ist-aus', aus);
      });
      [1, 2].forEach((f) => {
        w.querySelectorAll('[data-rs-farbe-status="' + f + '"]').forEach((el) => {
          el.hidden = !!(mFarbe[f] && mFarbe[f].farbe);
        });
      });
      ['eine', 'zwei', 'set'].forEach((mo) => {
        w.querySelectorAll('[data-rs-karte-status="' + mo + '"]').forEach((el) => {
          el.hidden = !!mAkt[mo];
        });
      });
      GROESSEN.forEach((g) => {
        w.querySelectorAll('[data-rs-groesse-status="' + g + '"], [data-rs-segment-status="' + g + '"]').forEach((el) => {
          el.hidden = !!mAkt.groessen[g];
        });
      });
      const ohne = GROESSEN.filter((g) => !mAkt.groessen[g]);
      const ohneText =
        ohne.length && ohne.length < GROESSEN.length
          ? muster(T.zweierAus || 'Nicht verfügbar: {groessen}.', { groessen: ohne.map((g) => g + NBSP + 'cm').join(', ') })
          : '';
      w.querySelectorAll('[data-rs-zweier-aus]').forEach((el) => {
        if (el.textContent !== ohneText) el.textContent = ohneText;
        el.hidden = !ohneText;
      });
    } else {
      // Ohne rs-preise.js bleibt alles wählbar (oben bei moeglich). Prüfung Preislogik B2 (02.10.2026): die Sperre, die
      // Liquid beim Laden an „Zwei Pfannen“ setzt (zwei_da), nimmt der Rückfall deshalb wieder ab; den Knopf sperrt die
      // Wache (rechne), der Zusatz „nicht verfügbar“ folgt oben k.zwei.ab.
      v.felder.querySelectorAll('[data-rs-feld="modus"]').forEach((inp) => {
        if (inp.disabled) inp.disabled = false;
      });
    }

    // Preisblock: seit E-169 „einzeln …“ neben dem Betrag ([data-rs-preis-zeile]), dahinter die Plakette, darunter
    // „Gesamtpreis“ mit „inkl. MwSt.“ und Versand (preisLabel, preisZusatz); leer heißt verborgen.
    // Geschrieben wird nur, was sich ändert: Beim Laden stimmen Text und hidden schon aus Liquid.
    if (v.art === 'buybox') {
      setzeText(w, '[data-rs-preis-label]', preisLabel());
      const pz = preisZusatz(vergleichWahl());
      [
        ['[data-rs-preis-plakette]', pz.plakette],
        ['[data-rs-preis-zeile]', pz.zeile]
      ].forEach(([sel, text]) => {
        setzeText(w, sel, text);
        w.querySelectorAll(sel).forEach((el) => {
          const aus = !text.trim();
          if (el.hidden !== aus) el.hidden = aus;
        });
      });
    }
    w.querySelectorAll('[data-rs-summe]').forEach((el) => {
      if (r) zaehlen(el, r.summe);
      else {
        el.textContent = '';
        el.dataset.rsCent = '';
      }
    });
    // Vergleichszeile „Einzeln zusammen …, du sparst …“ allein im Abschluss (rs-abschluss). Die Kaufbühne hat seit
    // E-168 kein [data-rs-vergleich] mehr, dort stehen Plakette und Zeile (oben); inKarte bleibt als Sperre für die Buybox.
    const inKarte = v.art === 'buybox' && (z.modus === 'set' || z.modus === 'zwei');
    w.querySelectorAll('[data-rs-vergleich]').forEach((el) => {
      const zeigen = !!(r && r.ersparnis) && !inKarte;
      el.hidden = !zeigen;
      const html = zeigen ? vergleichHTML(v.vergleich, r.einzelnSumme, r.ersparnis) : '';
      if (el.innerHTML !== html) el.innerHTML = html;
    });
    setzeHTML(w, '[data-rs-versand]', r ? versandHTML(r.summe) : '');
    setzeText(w, '[data-rs-nicht-lieferbar]', verf ? '' : nichtLieferbarText(r));

    // Abschluss: Größen in Worten, Link, Zusatzzeile
    if (v.art === 'abschluss') {
      setzeText(w, '[data-rs-groessen-text]', mitCm(muster(v.groessen[z.modus] || '', { groessen: groessenNamen() })));
      w.querySelectorAll('[data-rs-groessen-link]').forEach((el) => {
        el.hidden = z.modus === 'set';
      });
      w.querySelectorAll('[data-rs-zusatz-zeile]').forEach((el) => {
        el.hidden = !z.zusatz;
      });
    }

    if (v.knopf && !laeuft) knopfZustand(v.knopf, verf ? v.knopfText : T.knopfNichtLieferbar, !verf);
  }

  function knopfZustand(knopf, text, gesperrt) {
    const t = knopf.querySelector('[data-rs-kaufen-text]');
    if (t && t.textContent !== text) t.textContent = text;
    if (gesperrt) knopf.setAttribute('aria-disabled', 'true');
    else knopf.removeAttribute('aria-disabled');
  }

  function zaehlen(el, bis) {
    const alt = el.dataset.rsCent === '' ? NaN : Number(el.dataset.rsCent);
    el.dataset.rsCent = String(bis);
    const nr = (el.rsZaehlNr = (el.rsZaehlNr || 0) + 1);
    if (ruhig() || !Number.isFinite(alt) || alt === bis) {
      el.textContent = euro(bis);
      return;
    }
    const start = performance.now();
    const schritt = (jetzt) => {
      if (el.rsZaehlNr !== nr) return;
      const t = Math.min(1, (jetzt - start) / 300);
      el.textContent = euro(Math.round(alt + (bis - alt) * (1 - Math.pow(1 - t, 3))));
      if (t < 1) requestAnimationFrame(schritt);
    };
    requestAnimationFrame(schritt);
  }

  /* ---------- Bühne: die Pfannen der Auswahl im Randverhältnis 23,5 : 27,5 : 31 ----------
     Art wie in rs-kaufbuehne.liquid: 'oben' (Draufsicht aus den Theme-Assets, Vorlagen buehne-f-g),
     sonst 'foto' (Freisteller, Vorlagen schraeg-f-g), sonst 'schema'. Fehlt eine Draufsicht-Datei
     (Ladefehler), fällt die Bühne für den Rest des Besuchs auf die nächste Art zurück. */

  let obenKaputt = false;
  const vorgeladen = {};

  function bildArt(f, liste) {
    if (!obenKaputt && liste.every((g) => !!vorlage('buehne-' + f + '-' + g))) return 'oben';
    if (liste.every((g) => !!vorlage('schraeg-' + f + '-' + g))) return 'foto';
    return 'schema';
  }

  function pfanneErzeugen(g, f, art, key) {
    const el = document.createElement('div');
    el.className = 'rs-pfanne rs-pfanne--' + g + ' rs-pfanne--f' + f;
    el.dataset.rsKey = key;
    el.innerHTML =
      '<span class="rs-pfanne__name" aria-hidden="true"><span class="rs-pfanne__held">' +
      esc(D.held[g]) +
      '</span> ' +
      g +
      '&nbsp;cm</span>';
    const inhalt = art === 'oben' ? vorlage('buehne-' + f + '-' + g) : art === 'foto' ? vorlage('schraeg-' + f + '-' + g) : null;
    if (inhalt) el.appendChild(inhalt.cloneNode(true));
    else {
      el.insertAdjacentHTML(
        'beforeend',
        '<span class="rs-pfanne__schema" aria-hidden="true"><span class="rs-pfanne__stiel"></span><span class="rs-pfanne__rand"><span class="rs-pfanne__innen"><span class="rs-pfanne__boden"></span></span></span></span>'
      );
    }
    return el;
  }

  // Die andere Farbe erst bei Berührung der Farbwahl holen (06 16.3), dann steht sie beim Wechsel schon bereit
  function farbeVorladen(f) {
    if (vorgeladen[f] || obenKaputt) return;
    // Die Draufsicht-Bühne steht seit 26.09.2026 allein im Abschluss; fehlt sie, nichts holen
    if (!document.querySelector('[data-rs-buehne-reihe]')) return;
    vorgeladen[f] = true;
    GROESSEN.forEach((g) => {
      const t = vorlage('buehne-' + f + '-' + g);
      const img = t ? t.querySelector('img') : null;
      if (!img) return;
      const bild = new Image();
      bild.decoding = 'async';
      if (img.getAttribute('sizes')) bild.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) bild.srcset = img.getAttribute('srcset');
      bild.src = img.getAttribute('src');
    });
  }

  function reiheZeichnen(reihe, animieren) {
    const f = z.farbe;
    const liste = groessenListe();
    const art = bildArt(f, liste);
    const war = reihe.classList.contains('rs-buehne__reihe--oben')
      ? 'oben'
      : reihe.classList.contains('rs-buehne__reihe--foto')
        ? 'foto'
        : 'schema';
    const zahl = {};
    const neu = liste.map((g) => {
      zahl[g] = (zahl[g] || 0) + 1;
      return { g, key: f + '-' + g + '-' + zahl[g] };
    });
    const alte = Array.from(reihe.children).filter((el) => el.classList.contains('rs-pfanne') && !el.classList.contains('geht'));
    if (war !== art) {
      alte.forEach((el) => el.remove());
      alte.length = 0;
      reihe.classList.toggle('rs-buehne__reihe--oben', art === 'oben');
      reihe.classList.toggle('rs-buehne__reihe--foto', art === 'foto');
    }
    const vorhanden = new Map(alte.map((el) => [el.dataset.rsKey, el]));
    const bewegt = animieren && !ruhig() && typeof reihe.animate === 'function';
    const vorher = new Map();
    const gehen = [];
    if (bewegt) {
      vorhanden.forEach((el, key) => vorher.set(key, el.getBoundingClientRect().left));
    }
    const ordnung = neu.map((e) => {
      const da = vorhanden.get(e.key);
      if (da) {
        vorhanden.delete(e.key);
        return da;
      }
      return pfanneErzeugen(e.g, f, art, e.key);
    });
    vorhanden.forEach((el) => {
      if (bewegt) {
        gehen.push({ el, l: el.offsetLeft, t: el.offsetTop, b: el.offsetWidth });
      } else el.remove();
    });
    gehen.forEach(({ el, l, t, b }) => {
      el.classList.add('geht');
      el.style.position = 'absolute';
      el.style.left = l + 'px';
      el.style.top = t + 'px';
      el.style.width = b + 'px';
      const a = el.animate(
        [
          { opacity: 1, transform: 'none' },
          { opacity: 0, transform: 'translateX(-12px)' }
        ],
        { duration: 220, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }
      );
      a.onfinish = () => el.remove();
    });
    ordnung.forEach((el) => reihe.appendChild(el));
    if (bewegt) {
      ordnung.forEach((el) => {
        const l0 = vorher.get(el.dataset.rsKey);
        if (l0 === undefined) {
          el.animate(
            [
              { opacity: 0, transform: 'translateX(12px)' },
              { opacity: 1, transform: 'none' }
            ],
            { duration: 220, easing: 'cubic-bezier(.2,.7,.3,1)' }
          );
        } else {
          const dx = l0 - el.getBoundingClientRect().left;
          if (Math.abs(dx) > 0.5) {
            el.animate([{ transform: 'translateX(' + dx + 'px)' }, { transform: 'none' }], {
              duration: 220,
              easing: 'cubic-bezier(.2,.7,.3,1)'
            });
          }
        }
      });
    }
    return art !== 'schema';
  }

  function buehnenZeichnen(animieren) {
    let foto = true;
    document.querySelectorAll('[data-rs-buehne-reihe]').forEach((reihe) => {
      const f = reiheZeichnen(reihe, animieren);
      if (kb.contains(reihe)) foto = f;
    });
    kb.querySelectorAll('[data-rs-ph-buehne]').forEach((el) => {
      el.hidden = foto;
    });
    // Beschriftung der Bühne: an der Galerie-Slide (die Kaufbühne selbst ist aria-hidden), Text aus buehne_label
    const buehne = kb.querySelector('[data-rs-slide="buehne"]') || kb.querySelector('[data-rs-buehne]');
    if (buehne) buehne.setAttribute('aria-label', muster(T.buehneLabel, { farbe: farbName(z.farbe), groessen: groessenNamen() }));
  }

  /* ---------- Galerie: Scroll-Snap plus Knöpfe; Anzahl und Größe springen auf die Kaufbühne (Bild 2),
     die Farbe hält das Bild (26.09.2026, löst den Sprung aus E-42 ab) ---------- */

  const galerie = kb.querySelector('[data-rs-galerie]');
  const spur = galerie ? galerie.querySelector('[data-rs-galerie-spur]') : null;
  const slides = spur ? Array.from(spur.querySelectorAll('[data-rs-slide]')) : [];
  const zaehlerEl = galerie ? galerie.querySelector('[data-rs-zaehler]') : null;
  const zurueckEl = galerie ? galerie.querySelector('[data-rs-bild-schritt="-1"]') : null;
  const weiterEl = galerie ? galerie.querySelector('[data-rs-bild-schritt="1"]') : null;
  const daumenEl = galerie ? galerie.querySelector('[data-rs-daumen]') : null;
  // Runde 6 (E-158, bild1): Rahmen der Daumenleiste mit zwei Pfeilen (Maus und Finger, ohne Tab-Halt)
  const daumenRahmen = daumenEl ? daumenEl.closest('[data-rs-daumen-rahmen]') : null;
  // Punkte (mobil, Kaufseite Runde 2), seit E-178 auf dem Bild in der Fläche: nur Anzeige, folgen der gefilterten Bildzahl
  const punkteEl = galerie ? galerie.querySelector('[data-rs-punkte]') : null;
  // E-178 (Runde 20, Denny: Tipp aufs Bild zeigt es groß): Großansicht aus rs-fotodialog.js; ihre Liste sind die
  // sichtbaren Galerie-Bilder in derselben Folge (grossListe)
  const grossDlg = kb.querySelector('[data-rs-galerie-dialog]');
  const grossSpur = grossDlg ? grossDlg.querySelector('[data-rs-fotodialog-spur]') : null;
  let grossListe = [];
  let sichtbar = [];
  let daumenIndex = -1;
  // Ziel eines laufenden weichen Wechsels (gehe), bis die Spur dort steht oder die Zeit um ist
  let laufZiel = -1;
  let laufBis = 0;
  // Ladezeit Runde 3 (12.10.2026): Beim ersten Lauf von galerieNeu steht die Galerie meist schon so, wie Liquid sie für
  // die Startauswahl ausgibt (Farbe und Angebot). Dann bleiben die Slides unberührt (galerieNeu). Die Daumenleiste ist
  // unter 750 px nicht zu sehen (rs-kaufbuehne.css); dort entsteht sie erst, wenn das Fenster breiter wird (daumenMq).
  let galerieErstlauf = true;
  const daumenMq = daumenEl && typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 750px)') : null;
  // wahr, solange die Daumenleiste fehlt, weil sie gerade nicht zu sehen ist
  let daumenOffen = false;
  const daumenNoetig = () => !daumenMq || daumenMq.matches;

  // nurPruefen (Ladezeit Runde 3): nur sagen, ob die Slide Inhalt bekäme, ohne etwas zu bauen oder zu leeren
  function zusammensetzen(slide, art, nurPruefen) {
    const ziel = slide.querySelector('[data-rs-slide-inhalt]');
    if (!ziel) return false;
    const f = z.farbe;
    let quelle = art;
    if (art === 'inhalt') {
      const gr = String(D.griff || '');
      if (gr.indexOf('alle') > -1 || (gr.indexOf('einzel') > -1 && z.modus !== 'set')) quelle = 'oben';
    }
    const zahl = {};
    groessenListe().forEach((g) => {
      zahl[g] = (zahl[g] || 0) + 1;
    });
    const liste = Object.keys(zahl).map(Number);
    const teile = liste.map((g) => vorlage(quelle + '-' + f + '-' + g));
    if (nurPruefen) return teile.every(Boolean) || !!vorlage(art + '-rf-' + f) || !!(D.phGalerie && vorlage('ph-' + art));
    const frag = document.createDocumentFragment();
    if (teile.every(Boolean)) {
      const reihe = document.createElement('div');
      reihe.className = 'rs-galerie__reihe';
      liste.forEach((g, i) => {
        const fig = document.createElement('figure');
        fig.className = 'rs-galerie__teil rs-galerie__teil--' + g;
        fig.appendChild(teile[i].cloneNode(true));
        const cap = document.createElement('figcaption');
        cap.textContent = (zahl[g] > 1 ? zahl[g] + ' × ' : '') + g + NBSP + 'cm';
        fig.appendChild(cap);
        reihe.appendChild(fig);
      });
      frag.appendChild(reihe);
    } else if (vorlage(art + '-rf-' + f)) {
      frag.appendChild(vorlage(art + '-rf-' + f).cloneNode(true));
    } else if (D.phGalerie && vorlage('ph-' + art)) {
      frag.appendChild(vorlage('ph-' + art).cloneNode(true));
    } else {
      ziel.textContent = '';
      return false;
    }
    ziel.textContent = '';
    ziel.appendChild(frag);
    return true;
  }

  function blockAuswahl() {
    const ref = z.modus === 'eine' ? String(z.groesse1) : '24';
    const kandidaten = slides.filter((s) => {
      if (s.dataset.rsSlide !== 'block' || s.hasAttribute('data-rs-leer')) return false;
      const f = s.dataset.rsFarbe || 'beide';
      const a = s.dataset.rsAngebot || 'alle';
      return (f === 'beide' || Number(f) === z.farbe) && (a === 'alle' || a === z.modus);
    });
    const gruppen = new Map();
    kandidaten.forEach((s) => {
      const m = s.dataset.rsMotiv || '';
      if (!gruppen.has(m)) gruppen.set(m, []);
      gruppen.get(m).push(s);
    });
    const gewaehlt = new Set();
    gruppen.forEach((liste) => {
      const genau = liste.filter((s) => s.dataset.rsGroesse === ref);
      const alle = liste.filter((s) => (s.dataset.rsGroesse || 'alle') === 'alle');
      const vier = liste.filter((s) => s.dataset.rsGroesse === '24');
      (genau.length ? genau : alle.length ? alle : vier).forEach((s) => gewaehlt.add(s));
    });
    return gewaehlt;
  }

  function galerieNeu() {
    if (!spur) return;
    // Position halten: dasselbe Bild bleibt stehen; wechselt es mit der Farbe (eigene Blöcke je Farbe),
    // das gleiche Motiv in der neuen Farbe. Beim Start ist noch nichts sichtbar, die Galerie steht auf Bild 1.
    // Läuft gerade ein weicher Wechsel (Pfeil, Daumen, Sprung zur Kaufbühne), gilt sein Ziel als aktuelles
    // Bild; eine sofortige scrollLeft-Zuweisung bräche ihn sonst auf halber Strecke ab.
    const laeuft = laufZiel > -1 && performance.now() < laufBis;
    const vorher = sichtbar.length ? sichtbar[laeuft ? Math.min(laufZiel, sichtbar.length - 1) : index()] : null;
    const bloecke = blockAuswahl();
    // Ladezeit Runde 3: hidden nur bei Änderung schreiben; im ersten Lauf bleibt eine verborgene Slide „oben“ oder
    // „inhalt“, die keinen Inhalt bekäme, wie Liquid sie ausgibt (verborgen), statt geleert zu werden
    const erst = galerieErstlauf;
    galerieErstlauf = false;
    slides.forEach((s) => {
      const art = s.dataset.rsSlide;
      let an = true;
      if (art === 'oben' || art === 'inhalt') an = erst && s.hidden && !zusammensetzen(s, art, true) ? false : zusammensetzen(s, art);
      else if (art === 'vergleich') an = !!D.phGalerie;
      else if (art === 'block') an = bloecke.has(s);
      if (s.hidden !== !an) s.hidden = !an;
    });
    sichtbar = slides.filter((s) => !s.hidden);
    spur.classList.toggle('ist-ziehbar', sichtbar.length > 1);
    // Ladezeit Runde 3: unter 750 px keine Daumen (nicht zu sehen); daumenMq baut sie, sobald das Fenster breiter wird
    daumenOffen = !!daumenEl && !daumenNoetig();
    if (daumenEl) {
      daumenEl.textContent = '';
      (daumenOffen ? [] : sichtbar).forEach((s, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rs-daumen__bild';
        // Ein Tab-Halt für die ganze Leiste (role toolbar), Pfeiltasten wechseln (Runde 4, A18); navi setzt den aktiven auf 0
        b.tabIndex = -1;
        b.setAttribute('aria-label', muster(T.daumen, { n: i + 1, gesamt: sichtbar.length, motiv: s.dataset.rsMotiv || '' }));
        // Eigenes Vorschaubild je Farbe (Kaufbühne: data-rs-daumen-1/-2), wechselt mit der Farbe, weil die
        // Daumen bei jeder Änderung neu entstehen
        const eigen = s.getAttribute('data-rs-daumen-' + z.farbe);
        // Bühne: die größte Pfanne ganz statt eines Ausschnitts der ersten (Draufsicht-Dateien sind hochkant)
        const bilder = slideBilder(s);
        const buehne = s.dataset.rsSlide === 'buehne';
        const img = buehne ? bilder[bilder.length - 1] : bilder[0];
        if (eigen) {
          const c = document.createElement('img');
          c.src = eigen;
          c.width = 220;
          c.height = 220;
          c.alt = '';
          c.loading = 'lazy';
          c.decoding = 'async';
          c.className = 'rs-daumen__img';
          b.appendChild(c);
        } else if (img) {
          // Runde 4 (A20): ein eigenes img statt einer Kopie; sizes steht vor srcset, damit der Browser gleich die kleine
          // Datei wählt (-w200 bei den Theme-Assets), statt mit den sizes der großen Slide eine 720er zu laden
          const c = document.createElement('img');
          c.loading = 'lazy';
          c.decoding = 'async';
          c.alt = '';
          c.className = buehne ? 'rs-daumen__img rs-daumen__img--ganz' : 'rs-daumen__img';
          ['width', 'height'].forEach((a) => {
            if (img.getAttribute(a)) c.setAttribute(a, img.getAttribute(a));
          });
          c.sizes = '96px';
          if (img.getAttribute('srcset')) c.srcset = img.getAttribute('srcset');
          c.src = img.getAttribute('src') || img.currentSrc || '';
          b.appendChild(c);
        } else {
          const n = document.createElement('span');
          n.setAttribute('aria-hidden', 'true');
          n.textContent = String(i + 1);
          b.appendChild(n);
        }
        const bildEl = b.querySelector('img');
        if (bildEl) bildEl.draggable = false;
        b.addEventListener('click', () => gehe(i));
        daumenEl.appendChild(b);
      });
    }
    if (daumenEl) {
      daumenIndex = -1;
      if (!daumenOffen) {
        daumenEl.scrollLeft = 0;
        daumenRand();
      }
    }
    if (punkteEl) {
      punkteEl.textContent = '';
      sichtbar.forEach(() => {
        const p = document.createElement('span');
        p.className = 'rs-galerie__punkt';
        punkteEl.appendChild(p);
      });
      punkteEl.hidden = sichtbar.length < 2;
    }
    grossKnoepfe();
    if (vorher) {
      let ziel = sichtbar.indexOf(vorher);
      if (ziel < 0) {
        const motiv = vorher.dataset.rsMotiv || '';
        ziel = sichtbar.findIndex((s) => (s.dataset.rsMotiv || '') === motiv);
      }
      if (ziel > -1) {
        if (laeuft) {
          // weich weiter zum (evtl. verschobenen) Ziel, statt den Wechsel abzubrechen
          gehe(ziel);
        } else {
          const x = ziel * spur.clientWidth;
          if (Math.abs(spur.scrollLeft - x) > 1) spur.scrollLeft = x;
        }
      }
    }
    // Rückmeldung 02.10.2026: das Bild, das nach dem Wechsel steht, sofort freigeben (beim Start Bild 1, dort wartet nichts)
    // Wartende Bilder (noscript) zeigen, dass vor dem Start niemand gescrollt, getippt oder fokussiert hat: Das
    // Inline-Skript hinter der Spur gibt sonst schon alle frei (rs-kaufbuehne.liquid)
    if (erst && !spurBewegt && spur.querySelector('noscript[data-rs-slide-bild]')) ohneLayoutIndex = 0;
    try {
      slideFrei(sichtbar[index()]);
      navi();
    } finally {
      ohneLayoutIndex = -1;
    }
  }

  /* E-178 (Runde 20, Denny: Tipp aufs Bild zeigt es groß): Jede taugliche Slide bekommt einmal einen unsichtbaren Knopf,
     als Kind der Slide (nicht im Inhalt, den zusammensetzen leert). Tauglich sind nur Blöcke „Galerie-Bild“ mit einem
     Bild: nie die Bühne (live gezeichnet), kein Video, keine leeren Blöcke und nie product.media (R72). Der Name nennt
     Nummer und Zahl in der Großansicht und das Motiv. Ohne dialog oder ohne rs-fotodialog.js entstehen keine Knöpfe. */
  const GROSS_SIZES = '(min-width: 826px) 728px, (min-width: 750px) calc(92vw - 32px), 100vw';

  function grossTauglich(s) {
    return (
      s.dataset.rsSlide === 'block' &&
      !s.hasAttribute('data-rs-leer') &&
      !s.querySelector('video') &&
      (!!s.querySelector(':scope > .rs-galerie__inhalt > img') || !!s.querySelector(':scope > .rs-galerie__inhalt > noscript[data-rs-slide-bild]'))
    );
  }

  function grossKnoepfe() {
    if (!grossDlg || !grossSpur || typeof grossDlg.showModal !== 'function' || typeof window.rsFotodialogEinrichten !== 'function') return;
    grossListe = sichtbar.filter(grossTauglich);
    grossListe.forEach((s, i) => {
      let b = s.querySelector(':scope > .rs-galerie__gross');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'rs-galerie__gross';
        b.setAttribute('data-rs-gross', '');
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('aria-controls', grossDlg.id);
        s.appendChild(b);
      }
      const name = muster(T.grossAuf || 'Bild {n} von {gesamt} groß ansehen', { n: i + 1, gesamt: grossListe.length, motiv: s.dataset.rsMotiv || '' });
      if (b.getAttribute('aria-label') !== name) b.setAttribute('aria-label', name);
    });
  }

  // Liste der Großansicht bei jedem Öffnen neu: je Bild eine Kopie des img (ohne id, Klasse und fetchpriority, mit
  // großem sizes, spät geladen außer dem angetippten) und die Kopie seiner KI-Pille (Pflicht auch in Zoom und Vollbild,
  // Art. 50 Abs. 4 KI-VO, recht/runde-1.md 1.5). Die Alt-Texte samt „(… mit KI erstellt)“ reisen mit.
  function grossFuellen(start) {
    const frag = document.createDocumentFragment();
    grossListe.forEach((s, i) => {
      const img = s.querySelector(':scope > .rs-galerie__inhalt > img');
      const li = document.createElement('li');
      li.className = 'rs-fotodialog__bild';
      const medium = document.createElement('div');
      medium.className = 'rs-fotodialog__medium';
      const c = img.cloneNode(false);
      ['id', 'class', 'fetchpriority'].forEach((a) => c.removeAttribute(a));
      c.setAttribute('sizes', GROSS_SIZES);
      c.setAttribute('loading', i === start ? 'eager' : 'lazy');
      c.setAttribute('decoding', 'async');
      c.draggable = false;
      medium.appendChild(c);
      const ki = s.querySelector('.rs-ki-hinweis');
      if (ki) medium.appendChild(ki.cloneNode(true));
      li.appendChild(medium);
      frag.appendChild(li);
    });
    grossSpur.textContent = '';
    grossSpur.appendChild(frag);
  }

  function grossOeffnen(knopf) {
    const slide = knopf.closest('[data-rs-slide]');
    const start = grossListe.indexOf(slide);
    if (!grossDlg || !grossSpur || start < 0 || typeof window.rsFotodialogEinrichten !== 'function') return;
    galerieFrei(true);
    grossFuellen(start);
    // Beim Schließen fragt rs-fotodialog.js diesen Rückruf: die Galerie ohne Animation auf das zuletzt gezeigte Bild,
    // der Fokus auf dessen Knopf (nie auf eine inerte Slide)
    grossDlg.rsNachSchliessen = (n) => {
      const ziel = grossListe[n] || slide;
      const i = sichtbar.indexOf(ziel);
      if (i < 0) return null;
      laufZiel = -1;
      const x = i * spur.clientWidth;
      if (Math.abs(spur.scrollLeft - x) > 1) spur.scrollLeft = x;
      navi();
      return ziel.querySelector(':scope > .rs-galerie__gross');
    };
    window.rsFotodialogEinrichten(grossDlg).oeffnen(knopf, start);
  }

  // Daumenleiste in einer Reihe (Runde 2, 2 Nr. 5): das aktive Bild ins Sichtfeld der Leiste scrollen.
  // Nur die Leiste selbst scrollt (nie scrollIntoView, das bewegte die Seite); Ziel ist immer der Anfang
  // eines Daumens, passend zu scroll-snap. Ohne Überlauf (alle Daumen passen) passiert nichts.
  function daumenZeigen(b) {
    if (!daumenEl || !b) return;
    const max = daumenEl.scrollWidth - daumenEl.clientWidth;
    if (max <= 1) return;
    const pad = parseFloat(getComputedStyle(daumenEl).scrollPaddingLeft) || 0;
    const jetzt = daumenEl.scrollLeft;
    let ziel = jetzt;
    if (b.offsetLeft - pad < jetzt) ziel = b.offsetLeft - pad;
    else if (b.offsetLeft + b.offsetWidth + pad > jetzt + daumenEl.clientWidth) {
      const noetig = b.offsetLeft + b.offsetWidth + pad - daumenEl.clientWidth;
      const anfang = Array.from(daumenEl.children)
        .map((k) => k.offsetLeft - pad)
        .find((x) => x >= noetig - 1);
      ziel = anfang != null ? anfang : max;
    }
    ziel = Math.max(0, Math.min(max, ziel));
    if (Math.abs(ziel - jetzt) > 1) daumenEl.scrollTo({ left: ziel, behavior: ruhig() ? 'auto' : 'smooth' });
  }

  // Sichtbares Ende der Daumenleiste (Kritik 26.09.2026): Geht sie rechts oder links weiter, läuft sie
  // dort weich aus (Maske in rs-kaufbuehne.css). Am Ende und ohne Überlauf keine Maske.
  function daumenRand() {
    if (!daumenEl || daumenOffen) return;
    const max = daumenEl.scrollWidth - daumenEl.clientWidth;
    const x = daumenEl.scrollLeft;
    const rechts = max > 1 && x < max - 1;
    const links = max > 1 && x > 1;
    daumenEl.classList.toggle('ist-mehr-rechts', rechts);
    daumenEl.classList.toggle('ist-mehr-links', links);
    // E-158: die Pfeile am Rahmen folgen denselben Klassen
    if (daumenRahmen) {
      daumenRahmen.classList.toggle('ist-mehr-rechts', rechts);
      daumenRahmen.classList.toggle('ist-mehr-links', links);
    }
  }

  // E-158: Ziel einer Bewegung der Daumenleiste immer auf den Anfang eines Daumens runden (wie scroll-snap)
  function daumenAnfang(x) {
    const max = daumenEl.scrollWidth - daumenEl.clientWidth;
    const anfaenge = Array.from(daumenEl.children).map((k) => Math.min(max, k.offsetLeft)).concat([0, max]);
    return anfaenge.reduce((a, b) => (Math.abs(b - x) < Math.abs(a - x) ? b : a), 0);
  }

  // E-158: Pfeil an der Daumenleiste blättert eine Leistenbreite weiter. Rechts: der erste Daumen, der nicht ganz zu
  // sehen ist, steht danach vorn. Links: der letzte, der links nicht ganz zu sehen ist, steht danach hinten.
  function daumenBlaettern(richtung) {
    if (!daumenEl) return;
    const kinder = Array.from(daumenEl.children);
    const breite = daumenEl.clientWidth;
    const max = daumenEl.scrollWidth - breite;
    const x = daumenEl.scrollLeft;
    let ziel;
    if (richtung > 0) {
      const k = kinder.find((b) => b.offsetLeft + b.offsetWidth > x + breite + 1);
      ziel = k ? k.offsetLeft : max;
    } else {
      const vorn = kinder.filter((b) => b.offsetLeft < x - 1);
      const k = vorn[vorn.length - 1];
      ziel = k ? kinder.map((b) => b.offsetLeft).find((o) => o >= k.offsetLeft + k.offsetWidth - breite - 1) : 0;
    }
    ziel = Math.max(0, Math.min(max, ziel == null ? 0 : ziel));
    if (Math.abs(ziel - x) > 1) daumenEl.scrollTo({ left: ziel, behavior: ruhig() ? 'auto' : 'smooth' });
  }

  /* E-158 (bild1, Denny: „man kann die images nicht per hand sliden“): Mit Maus oder Stift ziehen. Wischen am Handy
     kann der Browser selbst, Touch bleibt deshalb unberührt; am Rechner ging die Leiste bisher nur mit Rad plus
     Umschalt. Ab 6 px Weg wird gezogen (darunter bleibt es ein Klick): Zeiger fangen, Scroll-Snap aus (Klasse
     ist-gezogen), die Fläche folgt dem Zeiger. Beim Loslassen entscheidet loslassen(dx, vx, links) das Ziel; die
     Klasse fällt erst, wenn die Fläche steht, damit der Snap nicht mitten in der Bewegung greift. Der Klick nach
     einem Zug wird geschluckt, damit kein Daumen und kein Knopf im Bild anspringt. */
  function ziehbar(el, loslassen) {
    let zug = null;
    let schluckenBis = 0;
    let fertigUhr = 0;
    const fertig = () => {
      window.clearTimeout(fertigUhr);
      fertigUhr = 0;
      el.classList.remove('ist-gezogen');
    };
    an(el, 'pointerdown', (e) => {
      if (e.pointerType === 'touch' || e.button !== 0 || e.isPrimary === false) return;
      if (el.scrollWidth - el.clientWidth <= 1) return;
      if (e.target.closest && e.target.closest('video[controls], input, select, textarea')) return;
      const jetzt = performance.now();
      zug = { id: e.pointerId, x: e.clientX, links: el.scrollLeft, gezogen: false, vx: 0, lx: e.clientX, lt: jetzt };
    });
    an(el, 'pointermove', (e) => {
      if (!zug || e.pointerId !== zug.id) return;
      const dx = e.clientX - zug.x;
      if (!zug.gezogen) {
        if (Math.abs(dx) < 6) return;
        zug.gezogen = true;
        window.clearTimeout(fertigUhr);
        el.classList.add('ist-gezogen');
        try {
          el.setPointerCapture(e.pointerId);
        } catch (f) {
          /* ohne Fangen zieht es nur, solange der Zeiger über der Fläche ist */
        }
      }
      const jetzt = performance.now();
      const dt = jetzt - zug.lt;
      if (dt > 0) zug.vx = 0.7 * ((e.clientX - zug.lx) / dt) + 0.3 * zug.vx;
      zug.lx = e.clientX;
      zug.lt = jetzt;
      el.scrollLeft = zug.links - dx;
      e.preventDefault();
    });
    const ende = (e) => {
      if (!zug || e.pointerId !== zug.id) return;
      const z0 = zug;
      zug = null;
      if (!z0.gezogen) return;
      // Stand der Zeiger still, bevor er losließ, zählt kein Schwung
      const vx = performance.now() - z0.lt > 100 ? 0 : z0.vx;
      schluckenBis = performance.now() + 400;
      loslassen((e.type === 'pointercancel' ? z0.lx : e.clientX) - z0.x, vx, z0.links);
      if ('onscrollend' in window) an(el, 'scrollend', fertig, { once: true });
      fertigUhr = window.setTimeout(fertig, 1300);
    };
    an(el, 'pointerup', ende);
    an(el, 'pointercancel', ende);
    an(
      el,
      'click',
      (e) => {
        if (performance.now() < schluckenBis) {
          e.preventDefault();
          e.stopPropagation();
          schluckenBis = 0;
        }
      },
      true
    );
    an(el, 'dragstart', (e) => e.preventDefault());
  }

  // Hauptbild: ab 15 % der Breite oder mit Schwung (0,3 px/ms) ein Bild weiter, sonst zurück; weit gezogen
  // zählt das Bild, das am meisten zu sehen ist
  function spurLoslassen(dx, vx, links) {
    const w = spur.clientWidth || 1;
    const von = Math.round(links / w);
    let n = Math.round(spur.scrollLeft / w);
    if (n === von) {
      const weit = Math.abs(dx) >= 0.15 * w || (Math.abs(vx) >= 0.3 && Math.sign(vx) === Math.sign(dx));
      if (weit && dx < 0) n = von + 1;
      else if (weit && dx > 0) n = von - 1;
    }
    gehe(n);
  }

  // Daumenleiste: mit etwas Schwung auslaufen und auf einen Daumenanfang einrasten
  function daumenLoslassen(dx, vx) {
    const max = daumenEl.scrollWidth - daumenEl.clientWidth;
    const ziel = daumenAnfang(Math.max(0, Math.min(max, daumenEl.scrollLeft - vx * 220)));
    daumenEl.scrollTo({ left: ziel, behavior: ruhig() ? 'auto' : 'smooth' });
  }

  // Ladezeit Runde 3: nur im ersten Lauf von galerieNeu gesetzt (0, solange spurBewegt falsch ist); dann liest index()
  // kein Layout. Sonst erzwang der Start am Handy ein volles Layout der Seite (gemessen rund 45 bis 60 ms bei CPU 4x).
  let ohneLayoutIndex = -1;
  function index() {
    if (ohneLayoutIndex > -1) return ohneLayoutIndex;
    if (!spur || !spur.clientWidth) return 0;
    return Math.max(0, Math.min(sichtbar.length - 1, Math.round(spur.scrollLeft / spur.clientWidth)));
  }

  function gehe(i) {
    if (!spur) return;
    const n = Math.max(0, Math.min(sichtbar.length - 1, i));
    const weich = !ruhig();
    laufZiel = weich ? n : -1;
    laufBis = weich ? performance.now() + 1200 : 0;
    spur.scrollTo({ left: n * spur.clientWidth, behavior: weich ? 'smooth' : 'auto' });
    window.setTimeout(navi, weich ? 360 : 0);
    // Nachlauf: Kommt die Spur nicht auf 2 px genau an, gibt laufBis den Zähler nach der Bewegung frei
    if (weich) window.setTimeout(navi, 1250);
  }

  function navi() {
    if (laufZiel > -1 && (performance.now() >= laufBis || Math.abs(spur.scrollLeft - laufZiel * spur.clientWidth) <= 2)) laufZiel = -1;
    const i = index();
    const gesamt = sichtbar.length;
    if (zaehlerEl && laufZiel === -1) {
      // Nur bei einem Wechsel und erst am Ziel schreiben: navi läuft bei jedem Scroll-Frame, und ein weicher
      // Sprung über mehrere Bilder soll keine Zwischenansagen bringen (JS-9)
      const text = muster(T.zaehler, { n: i + 1, gesamt });
      if (zaehlerEl.textContent !== text) zaehlerEl.textContent = text;
    }
    if (punkteEl) Array.from(punkteEl.children).forEach((p, j) => p.classList.toggle('ist-aktiv', j === i));
    // Ladezeit Runde 3: navi läuft bei jedem Scroll-Bild; inert, aria-current und tabIndex nur bei Änderung schreiben
    // (jedes Schreiben ist eine DOM-Änderung, auch mit gleichem Wert, und weckt die Beobachter der Seite)
    sichtbar.forEach((s, j) => {
      if (s.inert !== (j !== i)) s.inert = j !== i;
      if (j !== i) s.querySelectorAll('video').forEach((vid) => vid.pause());
    });
    if (daumenEl) {
      const kinder = Array.from(daumenEl.children);
      kinder.forEach((b, j) => {
        if (b.getAttribute('aria-current') !== String(j === i)) b.setAttribute('aria-current', String(j === i));
        if (b.tabIndex !== (j === i ? 0 : -1)) b.tabIndex = j === i ? 0 : -1;
      });
      if (i !== daumenIndex) {
        daumenIndex = i;
        daumenZeigen(kinder[i]);
      }
    }
    pfeileSperren(i === 0, i >= gesamt - 1);
  }

  // Runde 4 (A17): Am ersten und letzten Bild verschwindet ein Pfeil (E-142). Hat er gerade den Fokus, geht der Fokus
  // vorher an den anderen Pfeil, sonst an den aktiven Daumen oder die Spur; nie an body (WCAG 2.4.3). Erst entsperren,
  // was frei wird, dann sperren (wie paarSperren in rs-fotodialog.js).
  function pfeileSperren(zurueckAus, weiterAus) {
    const liste = [
      [zurueckEl, zurueckAus, weiterEl, weiterAus],
      [weiterEl, weiterAus, zurueckEl, zurueckAus]
    ];
    liste.forEach(([el, aus]) => {
      if (el && !aus && el.disabled) el.disabled = false;
    });
    liste.forEach(([el, aus, anderes, anderesAus]) => {
      if (!el || !aus || el.disabled) return;
      if (document.activeElement === el) {
        const daumen = daumenEl && daumenEl.offsetParent !== null ? daumenEl.querySelector('[aria-current="true"]') : null;
        if (anderes && !anderesAus) anderes.focus({ preventScroll: true });
        else if (daumen) daumen.focus({ preventScroll: true });
        else if (spur) {
          spur.setAttribute('tabindex', '-1');
          spur.focus({ preventScroll: true });
        }
      }
      el.disabled = true;
    });
  }

  if (daumenEl) {
    an(daumenEl, 'keydown', (e) => {
      const kinder = Array.from(daumenEl.children);
      const jetzt = kinder.indexOf(document.activeElement);
      if (jetzt < 0) return;
      let ziel = -1;
      if (e.key === 'ArrowRight') ziel = Math.min(kinder.length - 1, jetzt + 1);
      else if (e.key === 'ArrowLeft') ziel = Math.max(0, jetzt - 1);
      else if (e.key === 'Home') ziel = 0;
      else if (e.key === 'End') ziel = kinder.length - 1;
      else return;
      e.preventDefault();
      kinder.forEach((b, k) => {
        b.tabIndex = k === ziel ? 0 : -1;
      });
      kinder[ziel].focus({ preventScroll: true });
      gehe(ziel);
    });
  }

  /* ---------- Kaufbühne, Galerie Bild 2 (assets/rs-buehne.js, 26.09.2026) ----------
     Anzahl, Größe und der Größen-Finder (setzen) springen auf die Bühne; gemeldet wird frühestens
     WAHL_WARTEN ms nach dem Sprung und erst, wenn die Spur dort steht, damit man die Animation sieht.
     Steht die Galerie schon dort, bei Farbe und Zusatz: sofort, ohne Sprung (die Bühne blendet die Farbe
     selbst um). Beim Start und ohne Bewegung (ruhig): nur umschalten. Immer Farbe und Größen zusammen,
     die Farbe als Schlüssel schwarz/weissgrau (nie 1/2, das Modul läse 2 als Schwarz). */
  const WAHL_WARTEN = 400;
  const WAHL_SPRUNG = ['modus', 'g', 'z1', 'z2', 'setzen'];
  const wahlEl = spur ? spur.querySelector('[data-rs-wahlbuehne]') : null;
  const wahlSlide = wahlEl ? wahlEl.closest('[data-rs-slide]') : null;
  let wahlUhr = 0;
  let wahlAb = 0; // frühester Zeitpunkt der nächsten Meldung (Sprung, Farbumblendung)
  let wahlZiel = -1; // Index der Bühne, solange der Sprung dorthin läuft
  let wahlBis = 0; // spätestens dann melden, auch wenn die Spur nicht angekommen ist
  let wahlFarbe = null;
  let wahlGestartet = false;

  function wahlSenden() {
    window.clearTimeout(wahlUhr);
    wahlUhr = 0;
    if (signal.aborted || !wahlEl) return;
    const jetzt = performance.now();
    if (jetzt < wahlAb) {
      wahlUhr = window.setTimeout(wahlSenden, wahlAb - jetzt);
      return;
    }
    if (wahlZiel > -1 && Math.abs(spur.scrollLeft - wahlZiel * spur.clientWidth) > 2) {
      if (jetzt < wahlBis) {
        wahlUhr = window.setTimeout(wahlSenden, 50);
        return;
      }
      // Der weiche Sprung kam nicht an (der Browser hat ihn verworfen): ohne Animation auf die Bühne setzen
      spur.scrollLeft = wahlZiel * spur.clientWidth;
      laufZiel = -1;
      navi();
    }
    wahlZiel = -1;
    const farbe = z.farbe === 2 ? 'weissgrau' : 'schwarz';
    const sizes = groessenListe();
    // Ladezeit Runde 3 (12.10.2026): Beim Start hat rs-buehne.js die Bühne meist schon aus denselben Attributen gezeichnet
    // (eigener Start, wahlEl.__rsBuehne); dann kein zweites update, das in apply ein Layout erzwingt (offsetWidth)
    const schonGezeichnet = !wahlGestartet && !!wahlEl.__rsBuehne && wahlEl.getAttribute('data-farbe') === farbe &&
      wahlEl.getAttribute('data-groessen') === sizes.join(',');
    // Falls rs-buehne.js erst nach der Buybox startet, liest es den Stand von hier
    if (!schonGezeichnet) {
      wahlEl.setAttribute('data-farbe', farbe);
      wahlEl.setAttribute('data-groessen', sizes.join(','));
    }
    const animate = wahlGestartet && !ruhig();
    wahlGestartet = true;
    const B = window.RsBuehne;
    if (!schonGezeichnet && B && typeof B.update === 'function') {
      try {
        B.update({ color: farbe, sizes, animate });
      } catch (e) {
        /* die Bühne hält die Buybox nie an */
      }
    }
    // Das Modul blendet einen Farbwechsel 170 ms ab und zeichnet erst danach. Bis dahin nichts nachschieben,
    // sonst gewinnt sein älterer Zeitgeber (Schwarz, Weiß-Grau, Schwarz endete sonst auf Weiß-Grau).
    if (animate && wahlFarbe && wahlFarbe !== farbe) wahlAb = performance.now() + 220;
    wahlFarbe = farbe;
  }

  function wahlNachAenderung(feld, init) {
    if (!wahlEl) return;
    if (!init && wahlSlide && WAHL_SPRUNG.indexOf(feld) > -1) {
      const ziel = sichtbar.indexOf(wahlSlide);
      if (ziel > -1 && index() !== ziel) {
        const laeuftSchon = wahlZiel === ziel;
        if (!(laufZiel === ziel && performance.now() < laufBis)) gehe(ziel);
        if (!ruhig() && !laeuftSchon) {
          const jetzt = performance.now();
          wahlZiel = ziel;
          wahlAb = Math.max(wahlAb, jetzt + WAHL_WARTEN);
          wahlBis = jetzt + WAHL_WARTEN + 1200;
        }
      }
    }
    wahlSenden();
  }

  // Ohne Sprung beim Farbwechsel bleibt die Galerie stehen. Deshalb bei Berührung der Farbwahl vorab holen:
  // das Set-Foto (Blöcke vor der Bühne), das Gegenstück des gerade sichtbaren Bildes und die Pfanne der
  // Kaufbühne in dieser Farbe. Sonst stünde nach dem Wechsel kurz eine leere Fläche da (lazy und versteckt).
  const wahlPfanneGeholt = {};
  function galerieVorladen(f) {
    if (!spur) return;
    const jetzt = sichtbar[index()];
    const motiv = jetzt ? jetzt.dataset.rsMotiv || '' : null;
    const bis = wahlSlide ? slides.indexOf(wahlSlide) : -1;
    slides.forEach((s, i) => {
      if (s.dataset.rsSlide !== 'block' || s.dataset.rsFarbe !== String(f)) return;
      if ((bis > -1 && i < bis) || (motiv !== null && (s.dataset.rsMotiv || '') === motiv)) {
        slideFrei(s);
        s.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });
      }
    });
    if (wahlEl && !wahlPfanneGeholt[f]) {
      wahlPfanneGeholt[f] = true;
      const url = wahlEl.getAttribute(f === 2 ? 'data-pfanne-weissgrau' : 'data-pfanne-schwarz');
      // Rückmeldung 02.10.2026: dieselbe Auswahl wie die Bühne (srcset und sizes der Pfannen), sonst lädt es doppelt
      const satz = wahlEl.getAttribute(f === 2 ? 'data-pfanne-weissgrau-srcset' : 'data-pfanne-schwarz-srcset');
      const pfanne = wahlEl.querySelector('.rs-buehne__pfanne[sizes]');
      if (url) {
        const bild = new Image();
        bild.decoding = 'async';
        if (satz && pfanne) {
          bild.sizes = pfanne.getAttribute('sizes');
          bild.srcset = satz;
        }
        bild.src = url;
      }
    }
  }

  if (spur) {
    let wartet = false;
    an(spur, 
      'scroll',
      () => {
        if (wartet) return;
        wartet = true;
        requestAnimationFrame(() => {
          wartet = false;
          navi();
        });
      },
      { passive: true }
    );
    // Greift jemand selbst in die Spur (Wischen, Rad), zählt kein laufender Wechsel mehr, und die Bühne
    // wird nicht nachträglich erzwungen
    ['pointerdown', 'touchstart', 'wheel'].forEach((typ) =>
      an(spur, typ, () => {
        laufZiel = -1;
        wahlZiel = -1;
      }, { passive: true })
    );
    if (zurueckEl) an(zurueckEl, 'click', () => gehe(index() - 1));
    if (weiterEl) an(weiterEl, 'click', () => gehe(index() + 1));
    // E-158: Ziehen mit Maus und Stift, Pfeile an der Daumenleiste (Mausklick nimmt ihnen nicht den Fokus weg,
    // damit ein Pfeil, der am Ende verschwindet, keinen Fokus mitnimmt)
    ziehbar(spur, spurLoslassen);
    if (daumenEl) ziehbar(daumenEl, daumenLoslassen);
    if (daumenRahmen) {
      daumenRahmen.querySelectorAll('[data-rs-daumen-schritt]').forEach((p) => {
        an(p, 'mousedown', (e) => e.preventDefault());
        an(p, 'click', () => daumenBlaettern(Number(p.getAttribute('data-rs-daumen-schritt'))));
      });
    }
    // Tab durch die Daumen: der fokussierte Daumen steht immer ganz in der Leiste (sonst angeschnitten)
    if (daumenEl) {
      an(daumenEl, 'focusin', (e) => {
        const d = e.target.closest('.rs-daumen__bild');
        if (d) daumenZeigen(d);
      });
      let randWartet = false;
      const randBald = () => {
        if (randWartet) return;
        randWartet = true;
        requestAnimationFrame(() => {
          randWartet = false;
          daumenRand();
        });
      };
      an(daumenEl, 'scroll', randBald, { passive: true });
      an(window, 'resize', randBald, { passive: true });
      // Bilder der Daumen laden spät; erst dann steht die volle Breite fest
      an(daumenEl, 'load', randBald, true);
    }
    // Ladezeit Runde 3: Wird das Fenster breiter (Tablet quer, Fenster aufgezogen), entsteht die Daumenleiste jetzt
    if (daumenMq) {
      const daumenPruefen = () => {
        if (!signal.aborted && daumenOffen && daumenMq.matches) galerieNeu();
      };
      if (typeof daumenMq.addEventListener === 'function') an(daumenMq, 'change', daumenPruefen);
      else if (typeof daumenMq.addListener === 'function') daumenMq.addListener(daumenPruefen);
    }
    an(spur, 'click', (e) => {
      const k = e.target.closest('[data-rs-video-knopf]');
      if (!k) return;
      const vid = k.parentElement.querySelector('video');
      if (!vid) return;
      if (vid.paused) vid.play().catch(() => {});
      else vid.pause();
    });
    // E-178: Tipp aufs Bild öffnet die Großansicht. Nach einem Zug mit der Maus kommt der Klick hier nicht an (ziehbar
    // schluckt ihn in der Einfangphase); Wischen am Handy löst keinen Klick aus.
    an(spur, 'click', (e) => {
      const k = e.target.closest('[data-rs-gross]');
      if (k) grossOeffnen(k);
    });
    spur.querySelectorAll('video').forEach((vid) => {
      const k = vid.parentElement.querySelector('[data-rs-video-knopf]');
      if (!k) return;
      // Eigene Namen: an ist die Hilfsfunktion für Listener; eine Konstante an würde sie überdecken (JS-1)
      const zeichenAn = k.querySelector('[data-rs-video-an]');
      const zeichenAus = k.querySelector('[data-rs-video-aus]');
      const zeigen = () => {
        if (zeichenAn) zeichenAn.hidden = !vid.paused;
        if (zeichenAus) zeichenAus.hidden = vid.paused;
      };
      an(vid, 'play', zeigen);
      an(vid, 'pause', zeigen);
      an(vid, 'ended', zeigen);
    });
  }

  /* ---------- Express (E-56, E-63) ---------- */

  // Express bei jeder Auswahl ohne Zusatz (Denny, 30.09.2026: „bei allen … auch beim Duo“). Je Produkt ein
  // Formular (data-rs-express-form set|eine|zwei), weil Shopifys Knopf nur Varianten seines Produkts kauft; beim
  // Zweier ist es das Bundle pfannen-duo (eine Variante je Farbe und Größenpaar, D.duoVarianten). Duo 20 % (01.10.2026):
  // Die Variante kommt aus rechne(), dieselbe wie bei „In den Warenkorb“.
  function expressZeichnen() {
    const ex = kb.querySelector('[data-rs-express]');
    if (!ex) return;
    const f = String(z.farbe);
    let art = '';
    let v = null;
    if (!z.zusatz) {
      if (z.modus === 'set') {
        art = 'set';
        v = D.set && D.set[f];
      } else if (z.modus === 'eine') {
        art = 'eine';
        v = D.einzel && D.einzel[f] && D.einzel[f][String(z.groesse1)];
        // Ohne Warenkorb muss der Versandbetrag am Preis stehen (§ 6 Abs. 2 PAngV). Mit D.versandKosten nennt
        // versandHTML ihn (Weg A); ohne Betrag gilt Weg B (Rechts-Agent 26.09.2026): Express nur ab der Schwelle.
        if (v && !String(D.versandKosten || '').trim() && !(v.preis >= D.schwelle)) v = null;
      } else if (z.modus === 'zwei') {
        art = 'zwei';
        // Nur mit kaufbarem Pfannen-Duo (Wache zweierPaar: Variante da, lieferbar, Preis centgenau wie die Rechnung der
        // Seite); sonst zahlte die Kundin in der Kasse etwas anderes (Pflege: tools/relaunch/duo-bundle.mjs --preise)
        const r = rechne();
        v = r && r.verfuegbar && r.ids[0] && r.ids[0].id != null ? { id: r.ids[0].id, verfuegbar: true } : null;
      }
    }
    const wahl = art ? ex.querySelector('[data-rs-express-form="' + art + '"]') : null;
    const zeigen = !!(wahl && v && v.verfuegbar);
    ex.hidden = !zeigen;
    ex.querySelectorAll('[data-rs-express-form]').forEach((w) => {
      w.hidden = w !== wahl;
    });
    if (!zeigen) return;
    const inp = wahl.querySelector('[data-rs-express-id]');
    if (inp && String(inp.value) !== String(v.id)) {
      inp.value = String(v.id);
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ---------- Express erst bei Bedarf (Ladezeit 01.10.2026) ---------- */

  // Mit express_spaeter (rs-kaufbuehne.liquid) steht Shopifys Knopf als <template data-rs-express-knopf> in jedem
  // Express-Formular, davor ein Platzhalter mit Shopifys Ladebild. Eingesetzt wird erst, wenn der Express-Bereich auf
  // 200 px herankommt oder die erste Eingabe kommt (pointerdown, keydown), und dann nicht im Ereignis selbst, sondern
  // im Leerlauf danach (INP). Zuerst die sichtbare Auswahl, kurz darauf die übrigen, damit ein Wechsel wie bisher ohne
  // Wartezeit bleibt. Shopifys Kopfskript startet die Knöpfe beim Einfügen selbst; PaymentButton.init() stößt nach.
  // Eingaben in Shopifys Cookie-Banner zählen nicht als erste Eingabe (LPV-Runde 04.10.2026, expressBeobachten).
  let expressFrei = !('IntersectionObserver' in window);
  const imLeerlauf = (fn, frist) => {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: frist });
    else window.setTimeout(fn, 1);
  };
  function expressAnstossen() {
    const pb = window.Shopify && window.Shopify.PaymentButton;
    if (pb && typeof pb.init === 'function') pb.init();
  }
  function expressVorlagen(alle) {
    const ex = kb.querySelector('[data-rs-express]');
    if (!ex) return;
    let neu = false;
    ex.querySelectorAll('[data-rs-express-form]').forEach((w) => {
      if (!alle && (ex.hidden || w.hidden)) return;
      const t = w.querySelector('template[data-rs-express-knopf]');
      if (!t) return;
      const platz = w.querySelector('[data-rs-express-platz]');
      t.replaceWith(document.importNode(t.content, true));
      if (platz) platz.remove();
      neu = true;
    });
    if (!neu) return;
    expressAnstossen();
    // Rückfall: Ist Shopifys Element nach 5 s nicht definiert, einmal neu anstoßen
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      let da = false;
      window.customElements.whenDefined('shopify-accelerated-checkout').then(() => { da = true; });
      window.setTimeout(() => { if (!da) expressAnstossen(); }, 5000);
    }
  }
  function expressEinsetzen() {
    if (expressFrei) expressVorlagen(false);
  }
  function expressFreigeben() {
    if (expressFrei) return;
    expressFrei = true;
    imLeerlauf(() => {
      expressVorlagen(false);
      imLeerlauf(() => expressVorlagen(true), 4000);
    }, 1000);
  }
  function expressBeobachten() {
    const ex = kb.querySelector('[data-rs-express]');
    if (!ex || !ex.querySelector('template[data-rs-express-knopf]')) {
      // Schalter aus oder Theme-Editor: Knöpfe stehen schon im Formular, wie bisher
      expressFrei = true;
      return;
    }
    if (expressFrei) {
      imLeerlauf(() => expressVorlagen(true), 4000);
      return;
    }
    const io = new IntersectionObserver((e) => {
      if (e.some((x) => x.isIntersecting)) {
        io.disconnect();
        expressFreigeben();
      }
    }, { rootMargin: '0px 0px 200px 0px' });
    io.observe(ex);
    if (signal) signal.addEventListener('abort', () => io.disconnect());
    // LPV-Runde 04.10.2026 (Akte docs/resade/lpv-ladekette-2026-10-04.md): Die erste Eingabe war fast immer der Tipp in
    // Shopifys Cookie-Banner. Dann lud PayPal (am Handy rund 975 KB) neben dem Meta-Pixel, gedrosselt kam der PageView
    // nach 10,6 statt 6,2 s. Eingaben in Shopifys Einwilligungs-Oberfläche (Banner und Einstellungen: eine id mit
    // shopify-pc__ am Ziel oder darüber) geben nichts frei und lassen die Hörer stehen. Jede andere erste Eingabe gibt
    // frei wie bisher, danach gehen beide Hörer. Dafür hängen sie an einem eigenen Signal, das mit dem Lauf endet.
    const eingabe = new AbortController();
    if (signal) signal.addEventListener('abort', () => eingabe.abort());
    const ersteEingabe = (e) => {
      const ziel = e && e.target;
      if (ziel && typeof ziel.closest === 'function' && ziel.closest('[id^="shopify-pc__"]')) return;
      eingabe.abort();
      expressFreigeben();
    };
    ['pointerdown', 'keydown'].forEach((typ) => an(window, typ, ersteEingabe, { passive: true, signal: eingabe.signal }));
  }

  /* ---------- Galerie ab Bild 2 bei Bedarf (Rückmeldung 02.10.2026, Ladezeit am Handy) ---------- */

  // Späte Galeriebilder stehen in <noscript data-rs-slide-bild> (rs-kaufbuehne.liquid), die Bühne wartet mit
  // data-rs-spaet und data-rs-src (rs-buehne.liquid, rs-buehne.js). Chrome lud die Bilder trotz loading=lazy beim
  // Start, weil die Spur waagrecht im Fenster liegt. Ladezeit-Runde 03.10.2026 (C3): Im Leerlauf nach load kommt
  // nur das nächste Bild (bis dahin die beiden nächsten und nach 4 s alle, rund 263 KB ohne jedes Wischen). Alle
  // Bilder kommen beim waagrechten Scrollen der Spur (Wischen, Ziehen, Pfeile und Daumen scrollen sie), bei Tastatur
  // oder Fokus in der Galerie, vor der Großansicht und beim Berühren einer Farbe; das Bild, das nach einem Wechsel
  // steht, sofort. Ein Tippen allein gibt nichts frei. Beim ersten schnellen Wischen kann eine Slide kurz leer sein.
  // slideFrei, slideBilder und der frühe Auslöser galerieFrueh stehen auf Modulebene vor init.
  let galerieAlleFrei = false;
  function galerieFrei(alle) {
    if (galerieAlleFrei) return;
    if (alle) {
      galerieAlleFrei = true;
      slides.forEach(slideFrei);
      return;
    }
    const i = index();
    [i, i + 1].forEach((k) => slideFrei(sichtbar[k]));
  }
  function galerieBeobachten() {
    galerieGestartet = true;
    if (!spur || !spur.querySelector('noscript[data-rs-slide-bild], [data-rs-spaet]')) return;
    const alle = () => galerieFrei(true);
    an(spur, 'scroll', alle, { once: true, passive: true });
    ['keydown', 'focusin'].forEach((typ) => an(galerie, typ, alle, { once: true, passive: true }));
    // Gegenprüfung 02.10.2026: ohne requestIdleCallback (WebKit) mit Frist, sonst kämen alle Bilder direkt nach load
    const spaeter = (fn, frist) => {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: frist });
      else window.setTimeout(fn, frist);
    };
    const nachLoad = () => spaeter(() => galerieFrei(false), 1000);
    if (document.readyState === 'complete') nachLoad();
    else an(window, 'load', nachLoad, { once: true });
  }

  /* ---------- Kaufleiste (6.2) ---------- */

  function leistenText() {
    const kl = leiste.dataset;
    const f = farbName(z.farbe);
    let t;
    if (z.modus === 'set') t = (kl.rsTSet || 'Set') + ', ' + f;
    else if (z.modus === 'eine') t = held(z.groesse1) + ', ' + f;
    else {
      const [a, b] = paar();
      t = (kl.rsTZwei || 'Zwei Pfannen') + ', ' + (a === b ? 'zweimal ' + a + NBSP + 'cm' : a + ' und ' + b + NBSP + 'cm') + ', ' + f;
    }
    return z.zusatz ? t + '\n' + (kl.rsTZusatz || '') : t;
  }

  function leisteZeichnen(r, verf) {
    if (!leiste) return;
    setzeText(leiste, '[data-rs-kl-auswahl]', leistenText());
    setzeText(leiste, '[data-rs-kl-preis]', r ? euro(r.summe) : '');
    setzeHTML(leiste, '[data-rs-kl-versand]', r ? versandHTML(r.summe) : '');
    const k = leiste.querySelector('[data-rs-kl-knopf]');
    if (k && !laeuft) knopfZustand(k, verf ? leiste.dataset.rsTKnopf || T.knopf : leiste.dataset.rsTZurAuswahl || '', false);
  }

  // rs-cart.js setzt html.rs-warenkorb-offen; die übrigen Formen sind Rückfälle
  const drawerOffen = () =>
    !!document.querySelector('html.rs-warenkorb-offen, dialog[open], [data-rs-drawer][open], [data-rs-drawer].ist-offen');

  function tastaturOffen() {
    const a = document.activeElement;
    if (a && a.matches && a.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]), textarea, select, [contenteditable="true"]')) return true;
    const vv = window.visualViewport;
    return !!(vv && vv.height < window.innerHeight * 0.7);
  }

  function imFenster(el) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  // Fuß der Seite im Bild (Kritik 26.09.2026): Dann ist die Leiste aus, sonst läge sie über den Zahlarten
  // und der Firmenzeile. Gemeldet von einem IntersectionObserver (unten), ohne ihn per Messung beim Scrollen.
  const fussEl = document.querySelector('.rs-fuss') || document.querySelector('footer.footer') || document.querySelector('footer[role="contentinfo"]');
  let fussSichtbar = false;
  const fussImBild = () => {
    if (!fussEl) return false;
    if (typeof IntersectionObserver === 'function') return fussSichtbar;
    return imFenster(fussEl);
  };

  // Runde 4 (A21) und 4b (N10): Nach dem Tipp auf die Bewertungszeile bleibt die Leiste aus, bis man selbst scrollt
  // (wheel, touchmove, keydown); sie verdeckt weder den Pflicht-Hinweis im Band noch die erste Bewertung. Runde 3g
  // (13.10.2026): ebenso nach dem Tipp auf die Küchenzeile, die auf dasselbe Ziel springt.
  let nachBewSprung = false;
  const bewLinks = kb.querySelectorAll('.rs-bewzeile__link, a.rs-kz__link');
  if (bewLinks.length) {
    bewLinks.forEach((l) =>
      an(l, 'click', () => {
        nachBewSprung = true;
      })
    );
    ['wheel', 'touchmove', 'keydown'].forEach((t) =>
      an(window, t, () => {
        nachBewSprung = false;
      }, { passive: true })
    );
  }

  function leistePruefen() {
    if (!leiste || !kaufKnopf) return;
    const breite = Number(leiste.dataset.rsAbBreite) || 990;
    // Runde 4 (E-153): am Rechner nur mit „Auch am Rechner“ (B7); bei niedriger Fensterhöhe (Handy quer, 200 % Zoom)
    // nie, dort belegte sie ein Drittel bis die Hälfte des Bilds (B20)
    const rechner = leiste.dataset.rsRechner === 'an';
    let zeigen = false;
    if ((window.innerWidth < breite || rechner) && window.innerHeight >= 500) {
      const kopf = document.querySelector('.section-header');
      const kopfUnten = kopf ? Math.max(0, kopf.getBoundingClientRect().bottom) : 0;
      const knopfRahmen = kaufKnopf.getBoundingClientRect();
      zeigen = knopfRahmen.bottom < kopfUnten;
      // 12.10.2026 (Denny, „Preis und Knopf ohne Scrollen“): mit vor_knopf auch, solange der Kaufknopf noch unter
      // der Leiste liegt; kommt er über ihr ins Bild, tritt die Leiste zurück (die Höhe misst sie auch verborgen)
      if (!zeigen && leiste.dataset.rsVorKnopf === 'an') zeigen = knopfRahmen.top > window.innerHeight - leiste.offsetHeight;
      if (zeigen && abschluesse.some((a) => imFenster(a.querySelector('[data-rs-kaufen]')))) zeigen = false;
      if (zeigen && fussImBild()) zeigen = false;
      if (zeigen && (drawerOffen() || tastaturOffen())) zeigen = false;
      if (zeigen && nachBewSprung) zeigen = false;
    }
    if (leiste.classList.contains('ist-sichtbar') === zeigen) return;
    leiste.classList.toggle('ist-sichtbar', zeigen);
    document.documentElement.classList.toggle('rs-hat-kaufleiste', zeigen);
    if (zeigen) {
      const h = leiste.offsetHeight;
      document.documentElement.style.setProperty('--rs-kaufleiste-hoehe', h + 'px');
      // Runde 4b (N8, WCAG 2.4.11): Tastaturfokus nicht unter der eben eingeblendeten Leiste lassen. Nur :focus-visible,
      // angetippte Karten bleiben unberührt; höchstens so weit, dass das Ziel oben nicht unter den Kopf rutscht.
      const a = document.activeElement;
      if (a && a !== document.body && !leiste.contains(a) && a.matches && a.matches(':focus-visible')) {
        const r = a.getBoundingClientRect();
        const oben = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        const dy = Math.min(r.bottom - (window.innerHeight - h - 8), r.top - oben);
        if (dy > 0) springen(dy);
      }
    }
  }

  if (leiste) {
    let wartet = false;
    const bald = () => {
      if (wartet) return;
      wartet = true;
      requestAnimationFrame(() => {
        wartet = false;
        leistePruefen();
      });
    };
    an(window, 'scroll', bald, { passive: true });
    an(window, 'resize', bald, { passive: true });
    if (fussEl && typeof IntersectionObserver === 'function') {
      const fussBeobachter = new IntersectionObserver((eintraege) => {
        fussSichtbar = eintraege[eintraege.length - 1].isIntersecting;
        bald();
      });
      fussBeobachter.observe(fussEl);
      signal.addEventListener('abort', () => fussBeobachter.disconnect());
    }
    if (window.visualViewport) an(window.visualViewport, 'resize', bald, { passive: true });
    an(document, 'focusin', bald);
    an(document, 'focusout', bald);
    an(document, 'close', bald, true);
    an(document, 'rs:warenkorb:geaendert', bald);
    an(document, 'rs:warenkorb:geoeffnet', bald);
    an(document, 'rs:warenkorb:geschlossen', bald);
    an(document, 'rs:warenkorb:oeffnen', () => window.setTimeout(bald, 60));
    const kLink = leiste.querySelector('[data-rs-kl-link]');
    if (kLink) {
      an(kLink, 'click', (e) => {
        e.preventDefault();
        zurAuswahl('titel');
      });
    }
    const kKnopf = leiste.querySelector('[data-rs-kl-knopf]');
    if (kKnopf) an(kKnopf, 'click', () => kaufen(kKnopf, 'leiste'));
  }

  /* ---------- Warenkorb-Stand: Anzahl und Bambus-Zeile ----------
     E-178 (Runde 20, Denny: „Schon im Warenkorb“ entfernen): Der Hinweis und sein Link sind entfallen. Die Anzahl bleibt,
     weil kaufen() vor einem zweiten Versuch damit prüft, ob schon etwas angekommen ist (04 A3.5). Aus dem Warenkorb
     (detail.korb von rs-cart.js, sonst /cart.js) liest die Bambus-Zeile, ob schon eine Pfanne und ob Bambus drin liegt. */

  function korbLesen(k) {
    if (!k || !Array.isArray(k.items)) return;
    const bam = D.bambus ? Number(D.bambus.produkt) : NaN;
    pfanneImKorb = k.items.some((i) => pfannenProdukte.indexOf(Number(i.product_id)) > -1);
    bambusImKorb = k.items.some((i) => Number(i.product_id) === bam);
  }

  async function anzahlLaden() {
    const alt = anzahl;
    try {
      const antwort = await window.fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      const c = await antwort.json();
      if (c && typeof c.item_count === 'number') anzahl = c.item_count;
      korbLesen(c);
    } catch (e) {
      /* bleibt beim letzten Stand */
    }
    // Integration: Ist trotz Fehler etwas angekommen (422 mit Teiltreffer, Netz), ziehen Topf und
    // Drawer nach; rs-cart.js laedt still neu und sendet rs:warenkorb:geaendert (05 8.2 Schritt 6).
    if (anzahl !== alt && window.RSWarenkorb && typeof window.RSWarenkorb.aktualisieren === 'function') {
      Promise.resolve(window.RSWarenkorb.aktualisieren()).catch(() => null);
    }
    bambusZeichnen();
    return anzahl;
  }

  an(document, 'rs:warenkorb:geaendert', (e) => {
    const d = e.detail || {};
    const n =
      typeof d.item_count === 'number' ? d.item_count : d.cart && typeof d.cart.item_count === 'number' ? d.cart.item_count : typeof d.anzahl === 'number' ? d.anzahl : null;
    korbLesen(d.korb || d.cart);
    if (n === null) anzahlLaden();
    else {
      anzahl = n;
      bambusZeichnen();
    }
  });
  // Aus dem Verlauf zurück (bfcache): Anzahl und Bambus-Zeile frisch aus dem Warenkorb
  an(window, 'pageshow', (e) => {
    if (e.persisted) anzahlLaden();
  });

  /* ---------- Bambus-Küchenhelferset als Häkchen-Zeile (13.10.2026, ändert E-178) ----------
     Denny 13.10.2026 („Das Bambus-Helfer-Set bitte schöner machen“, Referenz Caraway): Die Zeile steht im Formular über
     dem Kaufknopf (rs-bambus-zeile.liquid), ihr Häkchen ist z.zusatz (change-Handler der Ansichten). Nichts ist
     vorausgewählt (§ 312a Abs. 3 BGB). Angehakt legen Kaufknopf, Kaufleiste und Abschluss Auswahl und Set in einem Aufruf
     hinein (rechne, rs-preise.js); Express fällt dann weg (expressZeichnen). Liegt Bambus schon im Warenkorb, ist die
     Zeile verborgen und nie angehakt. Der Knopf im Produktblatt (Runde 24) legt weiter dazu: bei Pfanne im Warenkorb
     das Set allein („Dazulegen“), sonst Auswahl und Set in einem Aufruf („Mit Auswahl dazulegen“, der Satz darüber sagt
     es), gerechnet ohne Häkchen. Allein kommt Bambus nie in die Kasse: Die Regel „nur mit Pfanne“ in rs-cart.js nimmt
     es sonst wieder heraus. */

  function bambusZeichnen() {
    if (!bambusEl) return;
    if (bambusEl.hidden !== bambusImKorb) bambusEl.hidden = bambusImKorb;
    // Liegt Bambus im Warenkorb, ist die Zeile verborgen und nie angehakt; sonst legte der Kaufknopf das Set unsichtbar
    // ein zweites Mal hinein. init: true, damit keine Ansage die Meldung des Warenkorbs überschreibt.
    if (bambusImKorb && z.zusatz) {
      z.zusatz = false;
      aktualisieren({ feld: 'korb', init: true });
    }
    // Runde 24: Satz und Knopf stehen im Produktblatt
    if (bambusBlatt) {
      bambusBlatt.querySelectorAll('[data-rs-bambus-hinweis]').forEach((el) => {
        if (el.hidden !== pfanneImKorb) el.hidden = pfanneImKorb;
      });
    }
    // Solange etwas in den Warenkorb geht, gehören Text und Sperre des Knopfs kaufen() und freigeben()
    if (!bambusBlattKnopf || laeuft) return;
    const text = pfanneImKorb ? T.bambusKnopf : T.bambusKnopfMit;
    const t = bambusBlattKnopf.querySelector('[data-rs-kaufen-text]');
    if (t && text && t.textContent !== text) t.textContent = text;
    bambusBlattKnopf.removeAttribute('aria-disabled');
  }

  function bambusDazu() {
    // Auslöser ist der Kaufknopf direkt unter der Zeile (Prüfung 13.10.2026): Er zeigt wie beim Kauf Rad, „Wird
    // hinzugefügt …“ und nach 3 s den Langtext, und zu ihm gibt die Schublade den Fokus zurück (die Zeile ist dann
    // verborgen). „Details“ hat keinen Ladezustand; es und der Knopf im Blatt springen nur ohne Kaufknopf ein.
    const knopf = kaufKnopf || bambusAusloeser || bambusBlattKnopf;
    if (laeuft || !D.bambus || !knopf) return;
    const bambus = { id: Number(D.bambus.id), quantity: 1 };
    if (pfanneImKorb) {
      kaufen(knopf, 'zusatz', [bambus]);
      return;
    }
    // Ohne Pfanne im Warenkorb die gewählte Auswahl mit; ist sie gerade nicht bestellbar, zur Auswahl (wie die Kaufleiste).
    // Gerechnet ohne Häkchen, sonst käme das Set bei angehakter Zeile zweimal in den Aufruf.
    const r = rechne(Object.assign({}, z, { zusatz: false }));
    const items = r && r.verfuegbar ? itemsAus(r) : [];
    if (!items.length) {
      zurAuswahl('farbe');
      return;
    }
    kaufen(knopf, 'zusatz', items.concat([bambus]));
  }

  // Runde 24: Der Knopf im Produktblatt schließt erst das Blatt und legt danach dazu, wenn rs-fotodialog.js den Fokus an
  // „Details“ zurückgegeben hat; sonst holte die Rückgabe ihn aus dem Warenkorb wieder auf die Seite.
  if (bambusBlattKnopf) {
    an(bambusBlattKnopf, 'click', () => {
      if (bambusBlatt.open) {
        an(bambusBlatt, 'close', bambusDazu, { once: true });
        bambusBlatt.close();
      } else {
        bambusDazu();
      }
    });
  }

  /* ---------- Sprung zur Buybox (Größen-Finder, Pflege, Abschluss, Kaufleiste) ---------- */

  // Runde 24: Nach dem Sprung von Kachel 2 tragen die Karten der Angebotswahl 1,5 s einen Ring (Klasse rs-leuchtet,
  // rs-kaufbuehne.css); ein zweiter Tipp beginnt von vorn.
  let leuchtUhr = 0;
  function aufleuchten(el) {
    el.classList.remove('rs-leuchtet');
    void el.offsetWidth;
    el.classList.add('rs-leuchtet');
    clearTimeout(leuchtUhr);
    leuchtUhr = setTimeout(() => el.classList.remove('rs-leuchtet'), 1500);
  }

  function zurAuswahl(ziel) {
    let el = null;
    let block = null;
    let leuchten = null;
    // Runde 24: eine Größenwahl gibt es nur bei 1x und 2x; im Set geht der Sprung zur Angebotswahl (dort ändert man die
    // Anzahl). Sonst fiele der Fokus auf den Block des Sets, der keinen annimmt.
    if (ziel === 'groessen' && !kb.querySelector('fieldset[data-rs-groessen]:not([hidden])')) ziel = 'modus';
    if (ziel === 'zusatz') {
      // Bambus-Zeile (13.10.2026): Fokus auf ihr Häkchen; ist sie verborgen (Bambus liegt im Warenkorb), zur Auswahl
      const haken = bambusEl ? bambusEl.querySelector('input[data-rs-feld="zusatz"]') : null;
      if (haken && !haken.closest('[hidden]')) {
        el = haken;
        block = bambusEl;
      }
    } else if (ziel === 'farbe') el = kb.querySelector('[data-rs-gruppe="farbe"]');
    else if (ziel === 'groessen') el = kb.querySelector('[data-rs-groessen]:not([hidden])');
    else if (ziel === 'modus') {
      // Runde 24 (Kachel 2): zur Angebotswahl, der Fokus auf die gewählte Karte; das fieldset bekommt kein tabindex.
      // Nur die Angebots-Knöpfe: input:checked träfe zuerst die verborgene Größenwahl einer anderen Karte.
      const gruppe = kb.querySelector('[data-rs-gruppe="modus"]');
      el = gruppe ? gruppe.querySelector('input[data-rs-feld="modus"]:checked') || gruppe.querySelector('input[data-rs-feld="modus"]') : null;
      if (el) block = leuchten = gruppe;
    }
    if (!el && form) {
      el = form.querySelector('h2[tabindex]');
      block = form;
    }
    if (!el) return;
    if (!block) block = ziel === 'titel' || !ziel ? form : el;
    if (block) block.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
    el.focus({ preventScroll: true });
    if (leuchten) aufleuchten(leuchten);
  }

  an(document, 'click', (e) => {
    const zusatzLink = e.target.closest('[data-rs-zum-zusatz]');
    if (zusatzLink) {
      e.preventDefault();
      zurAuswahl('zusatz');
      return;
    }
    const gLink = e.target.closest('[data-rs-groessen-link]');
    if (gLink) {
      e.preventDefault();
      zurAuswahl('groessen');
    }
  });

  /* ---------- Runde 24: Kacheln unter dem Preis ---------- */

  // „groessen“ und „herd“ öffnen ihr Fenster (rs-kachel-fenster.liquid, über rs-fotodialog.js), „angebote“ springt zur
  // Angebotswahl. Runde 24b: Kachel 4 („neunzig“) öffnet ihr eigenes Fenster (data-rs-kachel-fenster="neunzig"); fehlt
  // es, wie in Runde 24 die Bedingungen aus rs-probekochen, sonst bleibt der Link ein Link. „Zur Auswahl“ und die Knöpfe
  // im Fenster springen erst nach dem Schließen, wenn rs-fotodialog.js den Fokus an die Kachel zurückgegeben hat; sonst
  // holte die Rückgabe ihn wieder dorthin.
  function fensterAuf(dlg, knopf) {
    if (!dlg || typeof dlg.showModal !== 'function' || typeof window.rsFotodialogEinrichten !== 'function') return false;
    if (!dlg.open) window.rsFotodialogEinrichten(dlg).oeffnen(knopf, 0);
    return true;
  }

  // Runde 24b: schließt das Fenster und setzt danach die Auswahl über rs:buybox:setzen (mit fokus: Sprung und Fokus wie
  // zurAuswahl, die Ansage im Preisblock sagt die neue Auswahl an)
  function ausFenster(el, detail) {
    const dlg = el.closest('dialog');
    const setzen = () => document.dispatchEvent(new CustomEvent('rs:buybox:setzen', { detail }));
    if (dlg && dlg.open) {
      an(dlg, 'close', setzen, { once: true });
      dlg.close();
    } else {
      setzen();
    }
  }

  const fenster90 = kb.querySelector('dialog[data-rs-kachel-fenster="neunzig"]');
  if (fenster90) kb.querySelectorAll('a[data-rs-kachel="neunzig"]').forEach((a) => a.setAttribute('aria-haspopup', 'dialog'));
  // Ohne bestellbares Set kein Knopf „Alle drei im Set“
  kb.querySelectorAll('[data-rs-kachel-set]').forEach((b) => { b.hidden = !hatSet; });

  an(kb, 'click', (e) => {
    const kachel = e.target.closest('[data-rs-kachel]');
    if (kachel) {
      const ziel = kachel.getAttribute('data-rs-kachel');
      if (ziel === 'angebote') {
        e.preventDefault();
        zurAuswahl('modus');
      } else if (ziel === 'neunzig') {
        if (fensterAuf(fenster90, kachel) || fensterAuf(document.querySelector('dialog[data-rs-bedingungen-dialog]'), kachel)) e.preventDefault();
      } else if (fensterAuf(document.getElementById(kachel.getAttribute('aria-controls')), kachel)) {
        e.preventDefault();
      }
      return;
    }
    // Runde 24b, Größenfenster: Pfanne antippen wählt diese Größe. Beim Zweier wird sie die erste Pfanne (der Zweier
    // bleibt), sonst „1x Pfanne“ in dieser Größe. G-A: der Knopf trägt die Größe; G-B: der Knopf ist leer, es gilt das
    // gewählte Feld davor. Ohne Einzelpfannen nur der Sprung zur Angebotswahl.
    const pfanne = e.target.closest('[data-rs-groesse-waehlen]');
    if (pfanne) {
      let g = Number(pfanne.getAttribute('data-rs-groesse-waehlen'));
      if (!GROESSEN.includes(g)) {
        const feld = pfanne.closest('fieldset') && pfanne.closest('fieldset').querySelector('input[type="radio"]:checked');
        g = feld ? Number(feld.value) : 24;
      }
      let detail = { fokus: 'modus' };
      if (z.modus === 'zwei') detail = { modus: 'zwei', groesse1: g, groesse2: z.groesse2, fokus: 'groessen' };
      else if (modusMoeglich('eine')) detail = { modus: 'eine', groesse1: g, fokus: 'groessen' };
      ausFenster(pfanne, detail);
      return;
    }
    const set = e.target.closest('[data-rs-kachel-set]');
    if (set) {
      ausFenster(set, { modus: 'set', fokus: 'modus' });
      return;
    }
    // Runde 24b, 90-Tage-Fenster: „Alle Bedingungen“ öffnet den Dialog aus rs-probekochen über dem Fenster; nach dem
    // Schließen steht der Fokus wieder auf dem Link. Ohne den Dialog führt der Link zur Seite 90 Tage.
    const bed = e.target.closest('[data-rs-kachel-bedingungen]');
    if (bed) {
      if (fensterAuf(document.querySelector('dialog[data-rs-bedingungen-dialog]'), bed)) e.preventDefault();
      return;
    }
    const weiter = e.target.closest('[data-rs-kachel-weiter]');
    if (!weiter) return;
    const dlg = weiter.closest('dialog');
    const ziel = weiter.getAttribute('data-rs-kachel-weiter');
    if (dlg && dlg.open) {
      an(dlg, 'close', () => zurAuswahl(ziel), { once: true });
      dlg.close();
    } else {
      zurAuswahl(ziel);
    }
  });

  an(document, 'rs:buybox:setzen', (e) => {
    const d = e.detail || {};
    if (d.modus && modusMoeglich(d.modus)) {
      z.modus = d.modus;
      if (d.modus === 'eine') z.groesse1 = GROESSEN.includes(Number(d.groesse1)) ? Number(d.groesse1) : 24;
      if (d.modus === 'zwei') {
        z.groesse1 = GROESSEN.includes(Number(d.groesse1)) ? Number(d.groesse1) : 24;
        z.groesse2 = GROESSEN.includes(Number(d.groesse2)) ? Number(d.groesse2) : 28;
      }
    }
    if (d.farbe != null) {
      const nr = farbNr(d.farbe);
      if (nr && D.farben[nr] && D.farben[nr].da) z.farbe = nr;
    }
    // E-178: detail.zusatz wirkt nicht. Das Bambus-Set wählt allein das sichtbare Häkchen der Bambus-Zeile (§ 312a Abs. 3
    // BGB), nie ein Ereignis.
    korrigieren();
    aktualisieren({ feld: 'setzen' });
    if (d.fokus) zurAuswahl(d.fokus === true ? 'titel' : d.fokus);
  });

  /* ---------- Zeichnen und Ansage ---------- */

  let ansageUhr = null;

  function ansageText(r, feld) {
    const f = farbName(z.farbe);
    if (!r) return erster(T.nichtLieferbar);
    if (feld === 'zusatz') return muster(z.zusatz ? T.ansageZusatzAn : T.ansageZusatzAus, { summe: euro(r.summe) });
    let kopf;
    if (z.modus === 'set') kopf = 'Set in ' + f + ', alle drei Größen';
    else if (z.modus === 'eine') kopf = held(z.groesse1) + ', in ' + f;
    else {
      const [a, b] = paar();
      kopf = 'Zwei Pfannen in ' + f + ', ' + (a === b ? 'zweimal ' + held(a) : held(a) + ', und ' + held(b));
    }
    let text = kopf + ': ' + euro(r.summe) + '.';
    // Runde 2 (2 Nr. 4): Ersparnis nur einmal, im Wortlaut der Karte. Beim Set steht sie im Namen der
    // Set-Karte (Label des Radios), den der Screenreader schon beim Wählen vorliest, deshalb hier nicht.
    // Beim Zweier ist „Du sparst …“ kein Feldname und ändert sich mit den Größen: einmal ansagen.
    if (z.modus === 'zwei') {
      const zs = zweierErsparnis();
      if (zs > 0) {
        // Der Betrag steht in der Ansage schon vorn; aus dem Kartensatz nur der Vergleich (E-62, Runde 4b)
        // E-173 (Gegenprüfung): dieselbe Einzelsumme wie „einzeln …“ im Preisblock, mit Bambus samt dessen Preis
        const vz = vergleichWahl();
        const ein = vz ? vz.einzeln : zweierEinzeln();
        const tpl = String(T.zweierSparen || 'Du sparst {ersparnis}').replace(/[^.]*\{summe\}[^.]*\.\s*/, '');
        const satz = muster(tpl, { ersparnis: euro(zs), einzeln: ein != null ? euro(ein) : '' });
        text += ' ' + satz + (/[.!]$/.test(satz) ? '' : '.');
      }
    }
    text += ' ' + (r.versandFrei ? T.ansageVersandFrei : T.ansageVersandKosten);
    // „Nicht lieferbar“ sagt die Statuszeile selbst an (role=status), hier nicht noch einmal (JS-12)
    return text;
  }

  function ansagen(text) {
    if (!ansageEl) return;
    window.clearTimeout(ansageUhr);
    ansageUhr = window.setTimeout(() => {
      ansageEl.textContent = '';
      requestAnimationFrame(() => {
        ansageEl.textContent = text;
      });
    }, 400);
  }

  function itemsAus(r) {
    const liste = [];
    (r && r.ids ? r.ids : []).forEach((x) => {
      if (x.id == null) return;
      const da = liste.find((y) => String(y.id) === String(x.id));
      if (da) da.quantity += x.menge || 1;
      else liste.push({ id: Number(x.id), quantity: x.menge || 1 });
    });
    return liste;
  }

  function aktualisieren({ feld = null, init = false } = {}) {
    const r = rechne();
    const verf = !!(r && r.verfuegbar);
    const k = karten(z.farbe);
    ansichten.forEach((v) => ansichtZeichnen(v, r, verf, k));
    buehnenZeichnen(!init);
    galerieNeu();
    wahlNachAenderung(feld, init);
    expressZeichnen();
    expressEinsetzen();
    leisteZeichnen(r, verf);
    if (!init) ansagen(ansageText(r, feld));
    document.dispatchEvent(
      new CustomEvent('rs:buybox:geaendert', {
        detail: Object.assign({}, z, {
          summe: r ? r.summe : null,
          einzelnSumme: r ? r.einzelnSumme : null,
          ersparnis: r ? r.ersparnis : null,
          verfuegbar: verf,
          items: itemsAus(r),
          init
        })
      })
    );
  }

  ansichten.forEach((v) => {
    an(v.felder, 'change', (e) => {
      const inp = e.target.closest('[data-rs-feld]');
      if (!inp) return;
      const f = inp.dataset.rsFeld;
      // Runde 4 (A2): Beim Kartenwechsel klappt die Größenwahl der vorigen Karte zu; die angetippte Karte bleibt stehen
      const karte = f === 'modus' ? inp.closest('.rs-karte') : null;
      const karteVorher = karte ? karte.getBoundingClientRect().top : 0;
      if (f === 'farbe') z.farbe = Number(inp.value) === 2 ? 2 : 1;
      else if (f === 'modus') {
        z.modus = inp.value;
        // Vorbelegung beim Moduswechsel (E-28): eine 24 cm, zwei 24 + 28 cm; die Farbe bleibt
        if (z.modus === 'eine') z.groesse1 = 24;
        if (z.modus === 'zwei') {
          z.groesse1 = 24;
          z.groesse2 = 28;
        }
      } else if (f === 'g' || f === 'z1') z.groesse1 = Number(inp.value);
      else if (f === 'z2') z.groesse2 = Number(inp.value);
      else if (f === 'zusatz') z.zusatz = !!inp.checked;
      // Ausverkauftes ist nicht wählbar; nach einem Farb- oder Moduswechsel die nächste bestellbare Größe
      korrigieren();
      aktualisieren({ feld: f });
      if (karte && karte.isConnected) {
        const d = karte.getBoundingClientRect().top - karteVorher;
        if (Math.abs(d) > 1) springen(d);
      }
    });
    if (v.art === 'buybox') {
      an(v.felder, 'submit', (e) => {
        e.preventDefault();
        kaufen(kaufKnopf, 'buybox');
      });
    } else if (v.knopf) {
      an(v.knopf, 'click', () => kaufen(v.knopf, 'abschluss'));
    }
  });
  // Früher Tipp (02.10.2026, F5): Ab hier hält der Handler oben jeden Tipp selbst an; der gemerkte wird jetzt abgeholt
  // und erst nach dem ersten Zeichnen ausgeführt (fruehenTippAusfuehren am Ende von starten)
  const fruehGemerkt = fruehenTippAbholen();

  // Draufsicht der Bühne: Ladefehler (Datei fehlt in assets) schaltet auf Freisteller oder Schema zurück
  function obenFehlt() {
    if (obenKaputt) return;
    obenKaputt = true;
    buehnenZeichnen(false);
    galerieNeu();
  }
  const istOben = (el) => !!(el && el.classList && el.classList.contains('rs-pfanne__foto--oben'));
  an(document, 'error', (e) => {
    if (istOben(e.target)) obenFehlt();
  }, true);
  document.querySelectorAll('img.rs-pfanne__foto--oben').forEach((img) => {
    if (img.complete && img.currentSrc && img.naturalWidth === 0) obenFehlt();
  });
  // Berührt jemand eine Farbwahl (Buybox oder Abschluss), beide Farben der Bühne und der Galerie vorladen
  const farbwahlNah = (e) => {
    if (e.target && e.target.closest && e.target.closest('.rs-farben')) {
      farbeVorladen(1);
      farbeVorladen(2);
      galerieVorladen(1);
      galerieVorladen(2);
    }
  };
  ['pointerover', 'touchstart', 'focusin'].forEach((typ) => an(document, typ, farbwahlNah, { passive: true }));

  /* ---------- Hinzufügen (8.2, E-23, E-51) ---------- */

  const fehlerSymbol = () => {
    const t = vorlage('icon-fehler');
    const d = document.createElement('div');
    if (t) d.appendChild(t.cloneNode(true));
    return d.innerHTML;
  };

  function fehlerZiel(quelle, knopf) {
    if (quelle === 'abschluss') {
      const a = knopf.closest('[data-rs-abschluss]');
      if (a) return a.querySelector('[data-rs-fehler]');
    }
    // Bambus-Zeile (13.10.2026): Fehler beim Dazulegen über das Produktblatt stehen am Kaufknopf direkt unter der Zeile;
    // die Zeile hat keinen eigenen Fehlerbereich (sonst träfe kb.querySelector hier zuerst ihren)
    return kb.querySelector('[data-rs-fehler]');
  }

  function fehlerLeeren() {
    document.querySelectorAll('[data-rs-kaufbuehne] [data-rs-fehler], [data-rs-abschluss] [data-rs-fehler]').forEach((el) => {
      el.textContent = '';
    });
  }

  // Dazu der Knopf im Bambus-Produktblatt (Runde 24); solange etwas in den Warenkorb geht, sind alle gesperrt
  function alleKnoepfe() {
    return Array.from(
      document.querySelectorAll(
        '[data-rs-kaufbuehne] [data-rs-kaufen], [data-rs-abschluss] [data-rs-kaufen], [data-rs-kaufleiste] [data-rs-kaufen], [data-rs-kaufbuehne] [data-rs-bambus-blatt-dazu]'
      )
    );
  }

  function freigeben(knopf) {
    laeuft = false;
    alleKnoepfe().forEach((b) => b.removeAttribute('aria-busy'));
    if (knopf) knopf.removeAttribute('aria-busy');
    const r = rechne();
    const verf = !!(r && r.verfuegbar);
    ansichten.forEach((v) => {
      if (v.knopf) knopfZustand(v.knopf, verf ? v.knopfText : T.knopfNichtLieferbar, !verf);
    });
    leisteZeichnen(r, verf);
    bambusZeichnen();
  }

  function warten(ms) {
    return new Promise((r) => window.setTimeout(r, ms));
  }

  function warteAufWarenkorb(ms) {
    return new Promise((erfuellen) => {
      let fertig = false;
      const ende = (wert) => {
        if (fertig) return;
        fertig = true;
        document.removeEventListener('rs:warenkorb:geaendert', h);
        erfuellen(wert);
      };
      const h = (e) => ende(e.detail || true);
      document.addEventListener('rs:warenkorb:geaendert', h);
      window.setTimeout(() => ende(null), ms);
    });
  }

  function fehlerZeigen(art, knopf, quelle, nochmal) {
    const ziel = fehlerZiel(quelle, knopf);
    if (!ziel) return;
    const text = art === 'bestand' ? T.fehlerBestand : art === 'netz' ? T.fehlerNetz : T.fehlerAnders;
    ziel.innerHTML =
      '<p class="rs-fehler__zeile"><span class="rs-fehler__icon" aria-hidden="true">' + fehlerSymbol() + '</span><span>' + esc(text) + '</span></p>';
    if (nochmal) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'rs-knopf rs-knopf--rahmen rs-fehler__nochmal';
      b.textContent = T.nochmal;
      b.addEventListener('click', nochmal);
      ziel.appendChild(b);
    }
    if (quelle === 'leiste') ziel.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'center' });
    ziel.focus({ preventScroll: quelle !== 'leiste' });
  }

  // Auswahl in Worten für die Ansage des Warenkorbs (Vorschau 10, 04 A5.11). Mit dem Häkchen der Bambus-Zeile oder den
  // Posten des Produktblatts (das Set allein heißt wie die Zeile, Auswahl plus Set „…, mit Bambus-Küchenhelferset“)
  function auswahlText(items) {
    const bid = D.bambus ? String(D.bambus.id) : '';
    const liste = Array.isArray(items) ? items : [];
    const mitBambus = z.zusatz || (!!bid && liste.some((x) => String(x.id) === bid));
    if (mitBambus && liste.length && liste.every((x) => String(x.id) === bid)) return T.bambusName || '';
    const f = farbName(z.farbe);
    let t;
    if (z.modus === 'set') t = 'Set in ' + f;
    else if (z.modus === 'eine') t = held(z.groesse1) + ', in ' + f;
    else {
      const [a, b] = paar();
      t = a === b ? 'Zweimal ' + a + ' cm in ' + f : 'Zwei Pfannen in ' + f + ', ' + a + ' und ' + b + ' cm';
    }
    return mitBambus ? t + ', mit Bambus-Küchenhelferset' : t;
  }

  // Ladezeit-Runde 03.10.2026 (A1, Absicherung): Ohne Warenkorb-Schicht (kein window.RSWarenkorb, etwa auf der
  // Startseite, wenn Kaufbühne, Abschluss oder Kaufleiste per auch_start dort stehen) öffnet sich nach dem Hinzufügen
  // kein Popup, und es kommt kein rs:warenkorb:geaendert; der Knopf wartete bis zu 8 s. Dann geht es direkt zur
  // Warenkorbseite (window.routes.cart_url aus dem Layout, sonst /cart). Der Knopf bleibt bis dahin gesperrt. Kommt
  // die Seite aus dem Verlauf zurück (bfcache), gibt pageshow ihn frei; bleibt die Seite stehen (Laden abgebrochen),
  // gibt ihn eine Uhr nach 8 s frei, wie es der Handschlag auch tat.
  function zurWarenkorbseite(knopf) {
    const ziel = (window.routes && window.routes.cart_url) || '/cart';
    if (ansageEl) ansageEl.textContent = T.ansageErfolg || '';
    const uhr = window.setTimeout(() => freigeben(knopf), 8000);
    window.addEventListener(
      'pageshow',
      (e) => {
        if (!e.persisted) return;
        window.clearTimeout(uhr);
        freigeben(knopf);
      },
      { once: true }
    );
    window.location.assign(ziel);
  }

  async function erfolg(knopf, quelle, items, antwort, flug) {
    const landung = flug ? flug.landen() : null;
    const warenkorb = warteAufWarenkorb(8000);
    // Vom Knopf aus senden: rs-cart.js nimmt das Ziel als Auslöser und gibt ihm beim Schließen den Fokus zurück
    const detail = { landung, items, antwort, quelle, farbe: z.farbe, auswahl: auswahlText(items) };
    knopf.dispatchEvent(new CustomEvent('rs:warenkorb:hinzugefuegt', { bubbles: true, detail }));
    // A1 (Absicherung): keine Warenkorb-Schicht, niemand hat den Handschlag übernommen; im Theme-Editor bleibt es beim
    // Warten (dort gibt Paket A die Schicht immer aus)
    if (!window.RSWarenkorb && !detail.geoeffnet && !(window.Shopify && window.Shopify.designMode)) {
      zurWarenkorbseite(knopf);
      return;
    }
    if (landung) await Promise.race([landung, warten(4000)]);
    // Handschlag mit rs-cart.js (E-23): detail.geoeffnet ist erfüllt, sobald der Drawer offen ist
    let geaendert = null;
    if (detail.geoeffnet && typeof detail.geoeffnet.then === 'function') {
      geaendert = await Promise.race([detail.geoeffnet.then(() => true), warten(8000).then(() => null)]);
    } else geaendert = await warenkorb;
    if (!geaendert) await anzahlLaden();
    if (ansageEl) ansageEl.textContent = T.ansageErfolg || '';
    const t = knopf.querySelector('[data-rs-kaufen-text]');
    freigeben(knopf);
    if (t) {
      const vorher = t.textContent;
      t.textContent = T.knopfErfolg;
      window.setTimeout(() => {
        if (!laeuft && t.textContent === T.knopfErfolg) t.textContent = vorher;
      }, 2000);
    }
  }

  // E-178: posten (optional) sind feste Posten an Stelle der Auswahl, vom Knopf im Bambus-Produktblatt: das Set allein
  // oder die Auswahl mit dem Set in einem Aufruf. Ohne posten legt kaufen die Auswahl hinein (angehakt samt Set).
  async function kaufen(knopf, quelle, posten) {
    if (!knopf || laeuft) return;
    let items;
    if (Array.isArray(posten) && posten.length) items = posten;
    else {
      const r = rechne();
      if (!r || !r.verfuegbar) {
        if (quelle === 'leiste') zurAuswahl('farbe');
        return;
      }
      items = itemsAus(r);
    }
    if (!items.length) return;
    const menge = items.reduce((t, x) => t + x.quantity, 0);
    const vorher = anzahl;

    // Ladezeit-Runde 03.10.2026 (C4): Erst die Anfrage, dann den Flug messen (rs-flug.js liest Knopf, Topf und Farbe
    // und baut erst nach dem ersten Bild), danach die eigenen Änderungen (Knöpfe sperren, Text „Wird hinzugefügt …“).
    // In der umgekehrten Folge las starte nach diesen Änderungen und erzwang im Klick ein Layout.
    const anfrage = window.fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    let flug = null;
    // E-178: Das Bambus-Set allein fliegt nicht als Pfanne in den Topf
    const bid = D.bambus ? String(D.bambus.id) : '';
    const mitPfanne = items.some((x) => String(x.id) !== bid);
    try {
      const F = RSFlug || window.RSFlug;
      if (mitPfanne && F && typeof F.starte === 'function') flug = F.starte({ knopf, farbe: z.farbe, groesse: groessteGroesse(), bewegung: D.bewegung });
    } catch (e) {
      flug = null;
    }

    laeuft = true;
    fehlerLeeren();
    alleKnoepfe().forEach((b) => b.setAttribute('aria-disabled', 'true'));
    knopf.setAttribute('aria-busy', 'true');
    const t = knopf.querySelector('[data-rs-kaufen-text]');
    if (t) t.textContent = T.knopfLaedt;
    const uhr = window.setTimeout(() => {
      if (flug) {
        flug.abbrechen();
        flug = null;
      }
      if (t) t.textContent = T.knopfLaedtLang;
    }, 3000);

    let antwort;
    let json = {};
    try {
      antwort = await anfrage;
      json = await antwort.json().catch(() => ({}));
    } catch (e) {
      window.clearTimeout(uhr);
      if (flug) flug.abbrechen();
      await anzahlLaden();
      freigeben(knopf);
      fehlerZeigen('netz', knopf, quelle, async () => {
        // Vor dem zweiten Versuch /cart.js laden, damit nichts doppelt landet (04 A3.5)
        const jetzt = await anzahlLaden();
        if (jetzt >= vorher + menge) {
          fehlerLeeren();
          laeuft = true;
          await erfolg(knopf, quelle, items, null, null);
        } else kaufen(knopf, quelle, posten);
      });
      return;
    }
    window.clearTimeout(uhr);
    if (!antwort.ok) {
      if (flug) flug.abbrechen();
      await anzahlLaden();
      freigeben(knopf);
      fehlerZeigen(antwort.status === 422 ? 'bestand' : 'anders', knopf, quelle, null);
      return;
    }
    await erfolg(knopf, quelle, items, json, flug);
  }

  /* ---------- Galerie am Rechner mitlaufend (Runde 2, 2 Nr. 5) ----------
     Die Bildspalte klebt ab 990 px unter dem Kopf (rs-kaufbuehne.css, .rs-kb__bild). Shrines Kopf blendet
     sich beim Runterscrollen aus und beim Hochscrollen ein (sticky_header_type on-scroll-up). Gemessen
     wird seine sichtbare Unterkante und als --rs-kb-kopf an die Bildspalte (.rs-kb__bild) gegeben: 0 px, solange er weg
     ist. Nach jedem Scroll-Ereignis wird 450 ms lang je Bild gemessen, damit auch das Einblenden des
     Kopfs (Shrine-Animation) mitgeht. Prüfung E-158: gemessen wird auf allen Breiten, denn mobil klebt der Spaltenkopf
     des Vergleichs; er bekommt denselben Wert als --rs-vgl-kopf und steht so unter dem eingeblendeten Kopf. */
  const kopfEl = document.querySelector('.section-header');
  if (kopfEl) {
    // Hauptthread 18.10.2026: Die Werte stehen an den Elementen, die sie lesen (.rs-kb__bild, Spaltenkopf des
    // Vergleichs), registriert ohne Vererbung (rs-kaufbuehne.css, rs-inhalt-a.css). An Section und Vergleich ließ jede
    // Änderung alle 1.040 Elemente der Kaufbühne neu rechnen: 15,9 ms je Schreiben bei CPU 4x, am Ziel 0,6 ms.
    const kbBild = kb.querySelector('.rs-kb__bild');
    const vergleiche = Array.from(document.querySelectorAll('.rs-vergleich--karte .rs-vergleich__tabelle thead'));
    let kopfWert = null;
    let kopfBis = 0;
    let kopfLaeuft = false;
    const kopfMessen = () => {
      const u = Math.max(0, Math.round(kopfEl.getBoundingClientRect().bottom));
      if (u === kopfWert) return;
      kopfWert = u;
      if (kbBild) kbBild.style.setProperty('--rs-kb-kopf', u + 'px');
      vergleiche.forEach((v) => v.style.setProperty('--rs-vgl-kopf', u + 'px'));
    };
    const kopfSchleife = () => {
      kopfMessen();
      if (performance.now() < kopfBis) requestAnimationFrame(kopfSchleife);
      else kopfLaeuft = false;
    };
    const kopfAnstossen = () => {
      kopfBis = performance.now() + 450;
      if (!kopfLaeuft) {
        kopfLaeuft = true;
        requestAnimationFrame(kopfSchleife);
      }
    };
    an(window, 'scroll', kopfAnstossen, { passive: true });
    an(window, 'resize', kopfAnstossen, { passive: true });
    kopfMessen();
  }

  /* ---------- Früher Tipp (02.10.2026, Diagnose G2) ----------
     Das kleine Skript hinter dem Kaufformular (rs-kaufbuehne.liquid) hält einen Tipp auf den Kaufknopf an, solange
     dieses Modul den Knopf noch nicht übernommen hat, und merkt sich die damals angehakte Auswahl (data-rs-vorgemerkt,
     Schlüssel aus form.rsFruehAuswahl). fruehenTippAbholen läuft direkt nach dem Binden des Kauf-Handlers: data-rs-bereit,
     gemerkten Tipp, Rad und einen Hinweis des Skripts abräumen. Bricht starten danach ab, dreht kein Rad weiter, und
     kein falscher Hinweis folgt. fruehenTippAusfuehren läuft nach dem ersten Zeichnen (Häkchen stehen dann auf z):
     gleiche Auswahl und nichts vor dem Start angetippt, dann kaufen; sonst Ansage der gültigen Auswahl, der Kunde sieht
     sie und tippt neu. Angetipptes übernimmt der Start oben (beruehrt), die Preise dazu hat der Kunde vorher nicht gesehen. */
  function fruehenTippAbholen() {
    if (!form) return null;
    form.setAttribute('data-rs-bereit', '');
    if (form.hasAttribute('data-rs-frueh-fehler')) {
      form.removeAttribute('data-rs-frueh-fehler');
      fehlerLeeren();
    }
    const gemerkt = form.getAttribute('data-rs-vorgemerkt');
    form.removeAttribute('data-rs-vorgemerkt');
    if (kaufKnopf) kaufKnopf.removeAttribute('aria-busy');
    return gemerkt;
  }

  function fruehenTippAusfuehren(gemerkt) {
    kb.removeAttribute('data-rs-vorlaeufig');
    if (gemerkt === null || gemerkt === undefined || !form || !kaufKnopf) return;
    const jetzt = typeof form.rsFruehAuswahl === 'function' ? form.rsFruehAuswahl() : null;
    if (jetzt === gemerkt && !beruehrt.length) kaufen(kaufKnopf, 'buybox');
    else ansagen(ansageText(rechne(), null));
  }

  /* ---------- Start ---------- */

  // Kaufbühne (neu) anbinden, auch nach einem Neustart im Theme-Editor; Bekanntes überspringt rs-buehne.js
  if (window.RsBuehne && typeof window.RsBuehne.init === 'function') {
    try {
      window.RsBuehne.init(kb);
    } catch (e) {
      /* ohne Bühne weiter */
    }
  }
  // Rückmeldung 02.10.2026: Galerie ab Bild 2 bei Bedarf; die Freigabe läuft erst im Leerlauf nach load
  galerieBeobachten();
  aktualisieren({ init: true });
  // Ladezeit Runde 3 (12.10.2026): Die erste Prüfung der Kaufleiste misst Layout. Sie läuft nach dem ersten Bild in eigener
  // Aufgabe, damit der Start kein Layout erzwingt; Scrollen und Größenwechsel prüfen wie bisher.
  if (leiste) requestAnimationFrame(() => window.setTimeout(() => {
    if (!signal.aborted) leistePruefen();
  }, 0));
  expressBeobachten();
  fruehenTippAusfuehren(fruehGemerkt);
}

/* ---------- Preise laden, Rückfall ohne rs-preise.js ---------- */

// asset_url liefert „//resade.de/cdn/…?v=…“; ein nackter Dateiname wäre für import() kein gültiger Pfad
function modulUrl(u) {
  const s = String(u || '');
  return /^(\/|\.\.?\/|https?:)/.test(s) ? s : './' + s;
}

async function preiseLaden() {
  if (window.RSPreise) return window.RSPreise;
  if (D && D.preiseUrl) {
    try {
      const m = await import(modulUrl(D.preiseUrl));
      return window.RSPreise || (m && (m.default || m));
    } catch (e) {
      return null;
    }
  }
  return null;
}

function eintrag(f, g) {
  const e = D.einzel && D.einzel[String(f)];
  return e ? e[g] || e[String(g)] || null : null;
}

// Duo 20 % (01.10.2026): Preis eines Pfannen-Duos wie rs-preise.js summeZweier, falls das Modul fehlt:
// floor((a + b) * (100 - p) / 100) in Cent, p = D.prozent ganzzahlig von 0 bis 99, sonst null
function duoSumme(a, b) {
  const p = D.prozent === null || D.prozent === undefined || D.prozent === '' ? NaN : Number(D.prozent);
  if (!Number.isInteger(p) || p < 0 || p >= 100) return null;
  if (typeof a !== 'number' || typeof b !== 'number' || !Number.isFinite(a) || !Number.isFinite(b)) return null;
  return Math.floor(((a + b) * (100 - p)) / 100);
}

// Wache wie rs-preise.js zweierPaar: kaufbar nur, wenn die Duo-Variante des Paars da ist, lieferbar ist und centgenau
// duoSumme kostet; grund 'duo_fehlt', 'duo_preis', 'duo_aus' oder null. null ohne Einzelpreise oder Prozentwert.
function duoPaar(f, g1, g2) {
  const a = Math.min(Number(g1), Number(g2));
  const b = Math.max(Number(g1), Number(g2));
  const ea = eintrag(f, a);
  const eb = eintrag(f, b);
  if (!ea || !eb) return null;
  const summe = duoSumme(ea.preis, eb.preis);
  if (summe === null) return null;
  const d = (D.duoVarianten && D.duoVarianten[a + '-' + b + '|' + String(f)]) || null;
  const dPreis = d && d.preis != null ? Number(d.preis) : null;
  const dLieferbar = d && d.verfuegbar !== undefined ? !!d.verfuegbar : true;
  let grund = null;
  if (!d || d.id == null || dPreis === null) grund = 'duo_fehlt';
  else if (dPreis !== summe) grund = 'duo_preis';
  else if (!dLieferbar) grund = 'duo_aus';
  return {
    a,
    b,
    einzeln: ea.preis + eb.preis,
    summe,
    ersparnis: ea.preis + eb.preis - summe,
    id: d && d.id != null ? d.id : null,
    kaufbar: grund === null,
    grund,
    einzelnLieferbar: !!(ea.verfuegbar && eb.verfuegbar)
  };
}

function lokalPreisDerWahl(w) {
  const f = String(w.farbe);
  let summe = null;
  let einzeln = null;
  let verfuegbar = true;
  let sperre = null;
  const ids = [];
  if (w.modus === 'set') {
    const s = D.set && D.set[f];
    if (!s) return null;
    summe = s.preis;
    verfuegbar = !!s.verfuegbar;
    ids.push({ id: s.id, menge: 1 });
    const e = GROESSEN.map((g) => eintrag(f, g));
    if (e.every((x) => x && x.verfuegbar)) einzeln = e.reduce((t, x) => t + x.preis, 0);
  } else if (w.modus === 'eine') {
    const e = eintrag(f, w.groesse1);
    if (!e) return null;
    summe = e.preis;
    verfuegbar = !!e.verfuegbar;
    ids.push({ id: e.id, menge: 1 });
  } else {
    // Duo 20 % (01.10.2026): eine Position, die Duo-Variante mit Menge 1, Preis aus der Formel (wie preisDerWahl)
    const pz = duoPaar(f, w.groesse1, w.groesse2);
    if (!pz) return null;
    summe = pz.summe;
    verfuegbar = pz.kaufbar;
    sperre = pz.grund;
    ids.push({ id: pz.id, menge: 1 });
    if (pz.kaufbar && pz.einzelnLieferbar) einzeln = pz.einzeln;
  }
  if (w.zusatz) {
    if (!D.bambus) return null;
    summe += D.bambus.preis;
    if (einzeln !== null) einzeln += D.bambus.preis;
    verfuegbar = verfuegbar && !!D.bambus.verfuegbar;
    ids.push({ id: D.bambus.id, menge: 1 });
  }
  const spar = einzeln !== null && einzeln > summe;
  return {
    summe,
    einzelnSumme: spar ? einzeln : null,
    ersparnis: spar ? einzeln - summe : null,
    verfuegbar,
    versandFrei: summe >= D.schwelle,
    ids,
    sperre
  };
}

function lokalKarten(f) {
  const lieferbar = GROESSEN.map((g) => eintrag(f, g)).filter((e) => e && e.verfuegbar);
  const eineAb = lieferbar.length ? Math.min(...lieferbar.map((e) => e.preis)) : null;
  // Duo 20 % (01.10.2026): „ab“ und Ersparnis nur aus kaufbaren Pfannen-Duos, wie rs-preise.js buyboxKarten
  const paare = [];
  GROESSEN.forEach((a, i) => {
    GROESSEN.slice(i).forEach((b) => {
      const pz = duoPaar(f, a, b);
      if (pz && pz.kaufbar) paare.push(pz);
    });
  });
  const zweiAb = paare.length ? Math.min(...paare.map((x) => x.summe)) : null;
  const zweiSparAb = paare.length ? Math.min(...paare.map((x) => x.ersparnis)) : null;
  const s = D.set && D.set[String(f)];
  const e = GROESSEN.map((g) => eintrag(f, g));
  let vergleich = null;
  // E-169: wie setErsparnis, die drei vollen Einzelpreise gegen das Set (seit E-184 auf Dennys Entscheidung)
  if (s && s.preis != null && e.every((x) => x && x.verfuegbar)) {
    const einzelnSumme = e.reduce((t, x) => t + x.preis, 0);
    const ersparnis = einzelnSumme - s.preis;
    if (ersparnis > 0) vergleich = { einzelnSumme, ersparnis, prozent: Math.floor((ersparnis * 100) / einzelnSumme + 1e-9) };
  }
  return {
    eine: { ab: eineAb },
    zwei: { ab: zweiAb, ersparnisAb: zweiSparAb },
    set: { preis: s ? s.preis : null, verfuegbar: !!(s && s.verfuegbar), vergleich }
  };
}

// E-168/E-169: wie rs-preise.js vergleichDerWahl, falls das Modul fehlt. Zweier (Duo 20 % (01.10.2026)): volle
// Einzelpreise und die Ersparnis des Pfannen-Duos, nur bei einem Nachlass über 0, mit kaufbarem Pfannen-Duo und
// lieferbaren Einzelpfannen; Set: die drei vollen Einzelpreise (lokalKarten), unabhängig vom Nachlass; mit Zusatz kommt
// der Bambus-Preis zu einzeln dazu.
function lokalVergleichDerWahl(w) {
  if (!w) return null;
  const f = String(w.farbe);
  let v = null;
  if (w.modus === 'zwei') {
    const prozent = Number(D.prozent);
    if (!(prozent > 0)) return null;
    const pz = duoPaar(f, w.groesse1, w.groesse2);
    if (!pz || !pz.kaufbar || !pz.einzelnLieferbar || !(pz.ersparnis > 0)) return null;
    v = { art: 'zwei', einzeln: pz.einzeln, ersparnis: pz.ersparnis, prozent };
  } else if (w.modus === 'set') {
    const sv = lokalKarten(f).set.vergleich;
    if (!sv) return null;
    v = { art: 'set', einzeln: sv.einzelnSumme, ersparnis: sv.ersparnis };
  } else {
    return null;
  }
  if (w.zusatz) {
    if (!D.bambus || D.bambus.preis == null) return null;
    v.einzeln += D.bambus.preis;
  }
  return v;
}
